const fiLocale = {
  test: `Testaa aluetta`,
  dashboard: `Kojelauta`,
  engage: `Ota mukaan`,
  assets: `Omaisuus`,
  submissions: `Lähetykset`,
  impact: `Vaikutus`,
  programmes: `Ohjelmat`,
  interactions: `Vuorovaikutuksia`,
  donations: `Lahjoitukset`,
  impact_strategy: `Vaikutusstrategia`,
  my_profile: `Oma profiili`,
  organisation: `Organisaatio`,
  users: `Käyttäjät`,
  profile: `Profiili`,
  help: `Auttaa`,
  logout: `Kirjaudu ulos`,
  insights: `Näkemyksiä`,
  data: `Data`,
  progress: `Edistyminen`,
  ideas: `Ideoita`,
  reviewed: `Arvosteltu`,
  in_progress: `Käynnissä`,
  pending_review: `Odottaa tarkistusta`,
  most_popular_theme: `Suosituin teema`,
  local_resident: `Paikallinen asukas`,
  local_business: `Paikallinen yritys`,
  charitable_group: `Hyväntekeväisyysryhmä`,
  other_stakeholder: `Muu sidosryhmä`,
  cultural: `Kulttuurista`,
  environmental: `Ympäristö`,
  economic: `Taloudellinen`,
  educational: `Koulutus`,
  social: `Sosiaalinen`,
  responder_types: `Vastaajatyypit`,
  most_popular_category: `Suosituin luokka`,
  green_spaces: `Vihreät tilat`,
  local_tourism: `Paikallinen matkailu`,
  skills_development: `Taitojen kehittäminen`,
  other: `Muut`,
  most_popular_sub_category: `Suosituin alaluokka`,
  grassland: `Niitty tai pelto`,
  burgers: `Hampurilaiset`,
  green_skills: `Vihreät taidot`,
  filters: `Suodattimet`,
  theme: `Teema`,
  category: `Luokka`,
  sub_category: `Alaluokka`,
  ideas_by_phase: `Ideoita vaiheittain`,
  oops: `Oho! Käyttäjätunnus/salasana saattaa olla väärä`,
  forgot_password: `Unohtuiko salasana?`,
  forgot_password_line1: `Jos sinulla on tili, olet saanut "Palauta salasana" -sähköpostin BizGive-tuesta. Luo uusi salasana seuraamalla sähköpostissa olevaa linkkiä.`,
  forgot_password_line2: `Tarkista myös roskapostikansiosi.`,
  forgot_password_line3: `Jos et saa sähköpostia, sinulla ei ehkä ole aktiivista tiliä. Ota yhteyttä BizGive-tukeen.`,
  forgot_password_header: `Tarkista postilaatikkosi`,
  incorrect_email_id: `Tarkista antamasi sähköpostiosoite.`,
  forget_password: `Unohda salasana`,
  forget_password_hint: `Käytä yli 8 merkkiä, isoa ja pientä kirjainta, numeroa ja erikoismerkkiä.`,
  date_submitted: `Lähetyspäivämäärä`,
  feedback_type: `Palautteen tyyppi`,
  need: `Tarve`,
  attributes: `Attribuutit`,
  happy_to_be_contacted: `Oletko tyytyväinen yhteydenottoon?`,
  contact_information: `Yhteystiedot`,
  the_sender_has_multiple_submissions: `Lähettäjällä on useita lähetyksiä.`,
  actions: `Toiminnot`,
  add_comment: `Lisää kommentti`,
  date_actioned: `Toimenpiteen päivämäärä`,
  actioned_by: `Toiminut`,
  back_to_map: `Takaisin karttaan`,
  submitter_type: `Lähettäjätyyppi`,
  submitter_location: `Lähettäjän sijainti`,
  submission_location: `Lähetyspaikka`,
  categories: `Luokat`,
  yes: `Kyllä`,
  no: `Ei`,
  save: `Tallentaa`,
  idea_location: `Idean sijainti`,
  please_populate: `Ole hyvä ja täytä`,
  comments_added_successfully: `Kommentit lisätty onnistuneesti`,
  see_location: `Katso Sijainti`,
  feedback: `Palaute`,
  feedback_by_phase: `Palaute vaiheittain`,
  feedback_location: `Palaute Sijainti`,
  comment: `Kommentti`,
  asset: `Omaisuus`,
  phase: `Vaihe`,
  idea: `Idea`,
  submitter: `Lähettäjä`,
  requestedContact: `Pyydetty yhteydenotto?`,
  collaborate: `Tee yhteistyötä`,
  contact_by_phase: `Yhteydenotot vaiheittain`,
  collaborate_location: `Yhteistyöpaikka`,
  number_of_employees: `Ei. Työntekijät`,
  global_annual_turnover: `Maailmanlaajuinen vuosiliikevaihto (£ milj.)`,
  industry: `Teollisuus`,
  services_provided: `Tarjotut palvelut`,
  services_description: `Palvelujen kuvaus`,
  renewable_experience: `Uusiutuva kokemus?`,
  requested_introduction_to_tier_one_contractors: `Pyydetyt esittelyt tason 1 urakoitsijoihin?`,
  organization_name: `Organisaation nimi`,
  website: `Verkkosivusto`,
  overview: `Yleiskatsaus`,
  all_projects: `Kaikki projektit`,
  total_visitors: `Vierailijat yhteensä`,
  feedback_submitted: `Palaute lähetetty`,
  ideas_submitted: `Ideat lähetetty`,
  collaborations_submitted: `Yhteistyöt lähetetty`,
  pending_actions: `Odottavat toimet`,
  three_month_historical_visitors: `3 kuukauden historialliset vierailijat`,
  submission_type: `Lähetyksen tyyppi`,
  collaborations: `Yhteistyöt`,
  applications: `Sovellukset`,
  action_required: `Toimia vaaditaan`,
  pending_response: `Odottaa vastausta`,
  pre_approved: `Esihyväksytty`,
  approved: `Hyväksytty`,
  declined: `Hylätty`,
  your_session_will_expire_in: `Istuntosi vanhenee…`,
  select_whether_you_would_like_to_stay_logged_in_or_log_out: `Valitse, haluatko pysyä kirjautuneena sisään vai ulos. Jos et tee mitään, sinut kirjataan automaattisesti ulos turvallisuussyistä.`,
  stay_logged_in: `Pysy kirjautuneena`,
  log_out: `Kirjaudu ulos`,
  all_phases: `Kaikki vaiheet`,
  login: `Kirjaudu sisään`,
  not_registered_yet: `Etkö ole vielä rekisteröitynyt?`,
  sign_up: `Rekisteröidy`,
  user_terms: `Käyttäjäehdot`,
  privacy_policy: `Tietosuojakäytäntö`,
  create_an_account_to_apply_for_support: `Luo tili tukeaksesi hakemista varten`,
  are_you_impact_funder_contact_us: `Oletko vaikuttajarahoittaja? Ota yhteyttä`,
  confirm_password: `Vahvista salasana`,
  password_must_include: `Salasanan tulee sisältää:`,
  more_than_eight_characters: `- Yli 8 merkkiä`,
  an_upper_and_lower_case_character: `- Isot ja pienet kirjaimet`,
  a_number: `- Numero`,
  a_special_character: `- Erityinen hahmo`,
  i_accept_the: `Hyväksyn ko`,
  register: `Rekisteröidy`,
  connect_with_funders_and_design_your_opportunities_to_create_positive_impact: `Ota yhteyttä rahoittajiin ja suunnittele mahdollisuutesi luodaksesi positiivisia vaikutuksia`,
  or_login_to_create_your_free_BizGive_account: `tai kirjaudu sisään luodaksesi ilmaisen BizGive-tilisi.`,
  discover: `Tutustu`,
  funding_programmes_and_create_a_profile_to_receive_alerts: `rahoitusohjelmia ja luo profiili hälytyksiä varten.`,
  submit: `Lähetä`,
  applications_auto_verified_against_funder_criteria: `hakemukset, jotka tarkistetaan automaattisesti rahoittajan kriteerien mukaan.`,
  share: `Jakaa`,
  content_track_impact_and_capture_funder_feedback: `sisältöä, seurata vaikutusta ja kerätä rahoittajien palautetta.`,
  here: `tässä`,
  please_enter_password: `Anna salasana`,
  ok: `Ok`,
  confirm_email: `Vahvista sähköposti`,
  log_in: `Kirjaudu sisään`,
  please_enter_email: `Kirjoita Sähköposti`,
  the_input_is_not_valid_email: `Syötetty sähköpostiosoite ei kelpaa!`,
  the_new_password_that_you_entered_do_not_match: `Antamasi uusi salasana ei täsmää!`,
  the_new_email_that_you_entered_do_not_match: `Antamasi uusi sähköpostiosoite ei täsmää!`,
  please_confirm_your_password: `Anna Vahvista salasana`,
  please_accept_the_user_terms: `Hyväksy käyttöehdot`,
  change_password: `Vaihda salasana`,
  password: `Salasana`,
  we_just_emailed: `Lähetimme juuri sähköpostia`,
  please_click_on_the_link_in_your_email_to_activate_your_account: `Napsauta sähköpostissasi olevaa linkkiä aktivoidaksesi tilisi`,
  please_enter_a_valid_password: `Anna kelvollinen salasana`,
  you_have_been_logged_out_due_to_inactivity: `Sinut on kirjattu ulos epäaktiivisuuden vuoksi...`,
  please_enter_a_valid_password_using_the_guidance_below: `Virhe - Anna kelvollinen salasana alla olevien ohjeiden mukaisesti.`,
  entity: `Entiteetti`,
  unique_visitors: `Ainutlaatuiset Vierailijat`,
  questions: `Kysymyksiä`,
  localQuestions: `Paikallisia kysymyksiä`,
  visitors: `Vierailijat`,
  visitor_id: `Vierailijatunnus`,
  answer: `Vastaus`,
  question_time: `Kyselytunti`,
  avg_question_per_visitor: `Keskim. Kysymys vierailijaa kohden`,
  media: `Media`,
  logo: `Logo`,
  profile_create: `Luo profiili`,
  lets_get_started: `Aloitetaan`,
  name_and_location: `Nimi ja sijainti`,
  what_is_the_legal_Name_of_your_entity: `Mikä on yhteisösi virallinen nimi?`,
  what_entity_name_would_like_to_be_displayed: `Minkä entiteetin nimen halutaan näkyvän?`,
  what_is_your_registered_address: `Mikä on rekisteröity osoitteesi?`,
  description: `Kuvaus`,
  add_your_description: `Lisää kuvauksesi`,
  add_your_social_media_details: `Lisää sosiaalisen median yhteystiedot`,
  what_is_your_website: `Mikä on verkkosivustosi?`,
  optional: `Valinnainen`,
  add_your_company_logo: `Lisää yrityksesi logo`,
  upload: `Lataa`,
  organization_profile: `Organisaation profiili`,
  description_company: `Kuvaus`,
  detail: `Yksityiskohta`,
  registered_address: `Rekisteröity osoite`,
  proceed: `Edetä`,
  previous: `Edellinen`,
  save_n_exit: `Tallenna ja poistu`,
  next: `Seuraavaksi`,
  enter: `Enter`,
  complete: `Täydellinen`,
  my_details: `Omat tiedot`,
  your_name: `Sinun nimesi`,
  phone_number: `Puhelinnumero`,
  job_title: `Työnimike`,
  biz_give_role: `BizGive-rooli`,
  member_since: `Jäsen vuodesta`,
  my_programmes: `Omat ohjelmat`,
  delete_file_confirmation: `Tiedoston poistamisen vahvistus`,
  please_confirm_you_are_happy_to_permanently_delete_this_file: `Vahvista, että haluat poistaa tämän tiedoston pysyvästi?`,
  delete: `Poistaa`,
  cancel: `Peruuttaa`,
  create_password: `Luo salasana`,
  invite_new_user: `Kutsu uusi käyttäjä`,
  regular_users: `Tavalliset käyttäjät`,
  can_not_view_or_edit_anything_by_default: `oletusarvoisesti voi tarkastella tai muokata mitään. Kaikki kutsutut käyttäjät alkavat tällä tilalla. Voit lisätä ne Ohjelmat-kohtaan nähdäksesi ja/tai muokataksesi kyseistä ohjelmaa ja siihen liittyvää sisältöä.`,
  organization_admins: `Organisaation järjestelmänvalvojat`,
  can_access_and_edit_everything_in_the_platform: `voi käyttää ja muokata kaikkea alustalla. Voit määrittää olemassa oleville käyttäjille tämän oikeuden tällä näytöllä.`,
  user_name: `Käyttäjänimi`,
  make_admin: `Tee Admin`,
  remove_admin: `Poista Admin`,
  invited: `KUTSUTU`,
  regular: `SÄÄNNÖLLINEN`,
  admin: `JÄRJESTELMÄNVALVOJA`,
  remove_user_from_your_organization: `Poista käyttäjä organisaatiostasi`,
  please_confirm_you_are_to_permanently_remove_this_user: `Vahvista, että aiot poistaa tämän käyttäjän pysyvästi?`,
  none_of_their_programmes_or_interaction_data_will_be_removed: `Mitään heidän ohjelmiaan tai vuorovaikutustietojaan ei poisteta`,
  remove_user: `Poista käyttäjä`,
  remove_admin_rights: `Poista järjestelmänvalvojan oikeudet`,
  remove: `Poistaa`,
  as_an_Organization_Admin: `organisaation järjestelmänvalvojana.`,
  they_will_then_only_be_able_to_view_and_edit_programmes_that_they_manage: `He voivat sitten tarkastella ja muokata vain hallitsemiaan ohjelmia.`,
  enter_email_address: `Anna sähköpostiosoite`,
  confirm_email_address: `Vahvista sähköpostiosoite`,
  invite: `Kutsu`,
  add_admin_rights: `Lisää järjestelmänvalvojan oikeudet`,
  make: `Tehdä`,
  an_organization_admin: `organisaation järjestelmänvalvoja`,
  they_will_be_able_to_view_and_edit_everything_in_your_organization: `He voivat tarkastella ja muokata kaikkea organisaatiossasi.`,
  charity_can_not_view_or_edit_anything_by_default: `oletusarvoisesti voi tarkastella tai muokata mitään. Kaikki kutsutut käyttäjät alkavat tällä tilalla. Voit lisätä ne sovelluksiin tarkastellaksesi ja/tai muokataksesi kyseistä sovellusta ja siihen liittyvää sisältöä.`,
  charity_can_access_and_edit_everything_in_the_platform: `voi käyttää ja muokata kaikkea alustalla. Voit määrittää olemassa oleville käyttäjille tämän oikeuden tällä näytöllä.`,
  none_of_their_applications_or_interaction_data_will_be_removed: `Mitään heidän sovelluksistaan ​​tai vuorovaikutustietojaan ei poisteta`,
  they_will_then_only_be_able_to_view_and_edit_applications_that_they_manage: `Tämän jälkeen he voivat tarkastella ja muokata vain hallitsemiaan sovelluksia.`,
  the_invited_user_already_has_an_account_linked_to_this_email_address: `Kutsutulla käyttäjällä on jo tähän sähköpostiosoitteeseen linkitetty tili. Tarkista käyttäjäluettelosi tai ota yhteyttä BizGiveen saadaksesi tukea.`,
  all_programmes: `Kaikki ohjelmat`,
  download: `Lataa`,
  search_placeholder: `Haku...`,
  actions_required: `Tarvittavat toimenpiteet`,
  opportunity: `Mahdollisuus`,
  date_applied: `Käyttöönottopäivämäärä`,
  date_requested: `Pyydetty päivämäärä`,
  net_vote: `Nettoäänestys (äänestäjät)`,
  date_approved: `Hyväksymispäivämäärä`,
  date_declined: `Päivämäärä Hylätty`,
  applied: `KÄYTETTY`,
  in_edit: `EDIT:ssä`,
  pre_approved_caps: `ENNAKKOHYVÄKSYTTY`,
  approved_caps: `HYVÄKSYTTY`,
  declined_caps: `hylätty`,
  review: `Arvostelu`,
  customize_your_download: `Mukauta latausta`,
  select_application_status: `Valitse Sovelluksen tila`,
  share_and_manage_voting: `Jaa ja hallitse äänestystä`,
  current_share_access_closing_date: `Nykyinen osakkeen käyttöoikeuden sulkemispäivä`,
  invited_users_will_receive_an_email_with_access_details: `Kutsutut käyttäjät saavat sähköpostin, jossa on pääsytiedot, ja ne ovat käytettävissä sulkemispäivään asti. He voivat nähdä vain äänensä.`,
  invited_voters: `Kutsutut äänestäjät`,
  add_email_address: `Lisää sähköpostiosoite`,
  reported_grants: `Raportoidut apurahat`,
  planned_grants: `Suunnitellut apurahat`,
  remaining_budget: `Jäljellä oleva budjetti`,
  total_budget: `Kokonaisbudjetti`,
  do_you_wish_to_request_indicators: `Haluatko pyytää indikaattoreita?`,
  the_entity_will_be_asked_to_create: `Yksiköä pyydetään luomaan indikaattoreita mahdollisuuksistaan, jotka on kohdistettu valittuihin tuloksiin.`,
  please_confirm_you_wish_to_complete_this_item: `Tämä vaihe on valmis.`,
  requested: `Pyydetty`,
  do_you_wish_the_applicant_to_create_indicators_to_measure_its_progress: `Haluatko hakijan luovan indikaattoreita mittaamaan edistymistään?`,
  volunteering: `Vapaaehtoistyö`,
  day: `Päivä`,
  inkind: `luontoissuorituksina`,
  budget_period_end: `Budjettikauden lopussa`,
  budget_available: `Budjetti saatavilla`,
  budget_amount: `Budjetin summa`,
  remaining: `Jäljellä`,
  select_filter: `Valitse suodatin`,
  donation_title: `Lahjoitus`,
  email_id_title: `Sähköpostitunnus`,
  add_user: `Lisää käyttäjä`,
  delete_title: `Poistaa`,
  add_title: `Lisätä`,
  delete_user: `Poista käyttäjä`,
  action_cannot_undone: `Tätä toimintoa ei voi kumota. Tilin järjestelmänvalvojat voivat silti käyttää kaikkia heidän hallinnoimiaan tilaisuuksia.`,
  confirm_title: `Vahvistaa`,
  adding_admin_rights: `Järjestelmänvalvojan oikeuksien lisääminen antaa käyttäjälle mahdollisuuden luoda mahdollisuuksia, päivittää organisaatioprofiilia, lisätä ja poistaa käyttäjiä sekä luoda ylläpitäjiä.`,
  remove_admin_rights_para: `Järjestelmänvalvojan oikeuksien poistaminen poistaa käyttäjältä mahdollisuuden luoda mahdollisuuksia, päivittää organisaatioprofiilia, lisätä ja poistaa käyttäjiä sekä luoda järjestelmänvalvojia.`,
  save_private: `Tallennettu (yksityinen)`,
  planned_shared: `Suunniteltu (jaettu)`,
  invoice_requested: `Laskua pyydetty`,
  invoice_received: `Lasku vastaanotettu`,
  reported_title: `Ilmoitettu`,
  confirmed_title: `Vahvistettu`,
  report_donation: `Ilmoita lahjoituksesta`,
  cancel_title: `Peruuttaa`,
  save_title: `Tallentaa`,
  grant: `Myöntää`,
  awarded: `Palkittu`,
  award_title: `Myöntää`,
  type_title: `Tyyppi`,
  invoice_title: `Laskuttaa`,
  condition_title: `Kunto`,
  reported_date_title: `Ilmoitettu päivämäärä`,
  next_action_title: `Seuraava toiminta`,
  donation_created: `Menestys - lahjoitus luotu`,
  donation_updated: `Menestys - lahjoitus päivitetty`,
  donation_deleted: `Onnistui - lahjoitus poistettu`,
  view_donation: `Katso Lahjoitus`,
  select_title: `Valitse`,
  approved_opportunities_planned_impact: `Hyväksytyt mahdollisuudet (suunniteltu vaikutus)`,
  achieved_impact: `Saavutettu vaikutus (valmiit mahdollisuudet)`,
  achieved_beneficiaries: `Saavutetut edunsaajat`,
  outputs_achieved: `Tulokset saavutettu`,
  content_received: `Vastaanotettu sisältö (saavutettu vaikutus)`,
  opportunity_name: `Hankkeen nimi`,
  entity_name: `Entiteetin nimi`,
  due_date: `Eräpäivä`,
  number: `Määrä`,
  approved_date: `Hyväksytty päivämäärä`,
  view: `Näytä`,
  primary_UN_SDG: `YK:n ensisijainen SDG `,
  opportunity_type: `Mahdollisuuden tyyppi`,
  charity_name: `Hyväntekeväisyysjärjestön nimi`,
  select_type: `Valitse tyyppi`,
  please_fill_amount: `Täytä määrä`,
  enter_title: `Enter`,
  please_enter_conditions: `kirjoita kunto`,
  please_select_action: `Valitse toiminto`,
  actions_title: `Toiminnot`,
  select_action: `Valitse Toiminto`,
  payment_reference: `Maksuviite`,
  please_select_amount: `Valitse summa`,
  enter_payment_reference: `Syötä maksuviite`,
  upload_counterpart_behalf: `Lataa lasku vastapuolen puolesta`,
  equivalent_value: `Vastaava arvo`,
  amount_title: `Määrä`,
  purchase_order: `Ostotilaus`,
  files_title: `Tiedostot`,
  company_name_title: `Yrityksen nimi`,
  programme_type_title: `Ohjelman tyyppi`,
  application_start_date: `Hakemuksen alkamispäivä`,
  application_end_date: `Hakemuksen päättymispäivä`,
  location_title: `Sijainti`,
  next_update_outcome: `Seuraava päivitys/tulos`,
  donations_by: `Lahjoitukset Tekijä`,
  decision_date: `Päätöksen päivämäärä`,
  decision_start_date: `Päätöksen alkamispäivä`,
  decision_end_date: `Päätöksen päättymispäivä`,
  opportunity_i_manage: `Hallitsemani tilaisuudet`,
  select_template: `Valitse Malli`,
  please_select_template: `Valitse malli`,
  save_draft: `Tallenna luonnos`,
  all_opportunities: `Kaikki mahdollisuudet`,
  excel_title: `Excel`,
  budget_period: `Budjettikausi`,
  latest_period: `Viimeisin kausi`,
  select_donation_status: `Valitse Lahjoituksen tila`,
  delete_file: `Poista tiedosto`,
  deleting_file_para: `Tämän tiedoston poistaminen poistaa sen pysyvästi`,
  delete_donation: `Poista lahjoitus`,
  delete_donation_para: `Tämän lahjoituksen poistaminen poistaa kaikki siihen liittyvät tiedot pysyvästi`,
  cancel_changes: `Peruuta muutokset`,
  remove_title: `Poistaa`,
  will_remove_changes_to_donation: `Tämä poistaa kaikki lahjoitukseen tehdyt muutokset`,
  edit_title_uppercase: `MUOKATA`,
  current_report_period: `Nykyinen raportointijakso`,
  current_report_open: `Nykyinen raportti auki`,
  current_report_close: `Nykyinen raportti Sulje`,
  manage_title: `Hallitse`,
  open_date: `Avauspäivämäärä`,
  close_date: `Sulkemispäivämäärä`,
  period_title: `Kausi`,
  reporter_title: `Reportteri`,
  edit_title: `Muokata`,
  about_me: `Tietoja minusta`,
  please_enter_valid_name: `Anna kelvollinen nimi`,
  please_enter_only_alphabets: `Anna vain aakkoset`,
  name_Title: `Nimi`,
  phone_number_title: `Puhelinnumero`,
  upload_purchase_order: `Lataa ostotilaus`,
  programme_dates: `Ohjelman päivämäärät`,
  programme_start: `Ohjelman aloitus`,
  programme_end: `Ohjelman loppu`,
  currency: `Valuutta`,
  current_budget_year_end: `Nykyinen budjettivuoden loppu:`,
  approved_summary: `Hyväksytty yhteenveto`,
  please_select_programme: `Valitse ohjelma`,
  generate: `Luo`,
  opportunities_supported: `Mahdollisuudet tuetut`,
  approved_opportunities: `Hyväksytyt mahdollisuudet`,
  planned_impact: `Suunniteltu vaikutus (hyväksytyt mahdollisuudet)`,
  grants: `Apurahat`,
  planned_beneficiaries: `Suunnitellut edunsaajat`,
  direct: `Suoraan`,
  indirect: `Epäsuora`,
  primary: `Ensisijainen`,
  secondary: `Toissijainen`,
  all: `Kaikki`,
  programme_name: `Ohjelman nimi`,
  reset: `Nollaa`,
  my_feedback: `Palautteeni`,
  feedback_title: `Palaute`,
  select_opportunity: `Valitse Mahdollisuus`,
  please_select_opportunity: `Valitse mahdollisuus`,
  select_report: `Valitse Raportti`,
  please_select_report: `Valitse raportti`,
  editing_title: `Muokkaus`,
  enabled_title: `Käytössä`,
  locked_title: `Lukittu`,
  content_title_uppercase: `SISÄLTÖ`,
  feedback_title_uppercase: `PALAUTE`,
  no_data: `Ei dataa`,
  program_status: `Ohjelman tila`,
  un_sdgs: `YK:n kestävän kehityksen tavoitteet`,
  more_title: `Lisää`,
  program_location: `Ohjelman sijainti`,
  asset_name: `Omaisuuden nimi`,
  asset_location: `Omaisuuden sijainti`,
  portfolio_title: `Portfolio`,
  review_title: `Arvostelu`,
  payment_date: `Maksupäivä`,
  secondary_UN_SDG: `YK:n toissijaiset kestävän kehityksen tavoitteet`,
  summary_title: `Tiivistelmä`,
  select_the_programme_you_wish_to_receive: `Valitse ohjelma, josta haluat saada raportin yllä valitusta omaisuudesta.`,
  manager: `Manager`,
  add_managers_who_can_invite_reporter: `Lisää johtajia, jotka voivat kutsua toimittajia puolestasi. Huomautus: Organisaatiosi sisäisiä käyttäjiä voidaan lisätä organisaatiostasi`,
  admin_page: `järjestelmänvalvojan sivu`,
  inviting_existing_user: `Olemassa olevan käyttäjän kutsuminen`,
  invite_new: `Kutsu uusi`,
  external_users: `ulkoisia käyttäjiä`,
  by_entering_their_email_address: `kirjoittamalla heidän sähköpostiosoitteensa`,
  optional_add_reporters: `Valinnainen. Lisää toimittajia, jotka laativat ohjelmaraportit resursseistasi.`,
  manage_report: `Hallinnoi raporttia`,
  add_asset: `Lisää omaisuus`,
  budget_history: `Budjettihistoria`,
  milestones: `Virstanpylväät`,
  programme_name_title: `Ohjelman nimi`,
  application: `Sovellus`,
  create: `Luoda`,
  comment_title: `Kommentti`,
  cash_donation_saved_successfully: `Käteislahjoitus säästyi.`,
  upload_invoice: `Lataa lasku`,
  upload_title: `Lataa`,
  confirm_receipt: `Vahvista kuitti`,
  received_title: `Vastaanotettu`,
  please_confirm_donation_received: `Vahvista, että tämä lahjoitus on vastaanotettu.`,
  success_donation_received: `Menestys - lahjoitus vastaanotettu`,
  success_invoice_uploaded: `Onnistui - lasku ladattu`,
  click_to_upload: `Napsauta ladataksesi`,
  settings: `Asetukset`,
  internal_only: `Vain sisäinen`,
  visibility_title: `Näkyvyys`,
  public_title: `Julkinen`,
  private: `Yksityinen`,
  completed: `Valmis`,
  content_package: `Sisältöpaketti`,
  please_select_interaction_status: `Valitse vuorovaikutuksen tila.`,
  go_back: `Mene takaisin`,
  budget_dates: `Budjetin päivämäärät`,
  budget_recurring: `Toistuva budjetti?`,
  objectives: `Tavoitteet`,
  supporting_materials: `Tukimateriaali`,
  web_links: `Web-linkit`,
  administrators: `Järjestelmänvalvojat`,
  application_criteria: `Soveltamiskriteerit`,
  documentation_required: `Asiakirjat vaaditaan`,
  available_support: `Saatavilla oleva tuki`,
  none: `Ei mitään`,
  eligibility_checklist: `Kelpoisuuden tarkistuslista`,
  location_supported: `Sijainti tuettu`,
  project_must_be_within: `Projektin on oltava sisällä`,
  of_this_location: `tästä sijainnista`,
  expand_all: `Laajenna kaikki`,
  entities_supported: `Tuetut kokonaisuudet`,
  mandatory: `Pakollinen`,
  expected_budget: `Odotettu budjetti`,
  per_opportunity: `Projektia kohti`,
  specific_skills_available: `Tietyt taidot saatavilla`,
  general_skills_available: `Yleiset taidot saatavilla`,
  any: `Mikä tahansa`,
  application_accepted_between: `Hakemukset hyväksytty`,
  donation_to_be_made_between: `Lahjoitus tehdään`,
  interim_update_requested: `Väliaikainen päivitys pyydetty`,
  final_report_requested: `Loppuraportti pyydetty`,
  show_all_goals: `Näytä kaikki maalit`,
  any_location: `Mikä tahansa sijainti`,
  apply: `Käytä`,
  eligibility: `Kelpoisuus`,
  before_applying_please_confirm_your_eligibility: `Ennen kuin haet, vahvista kelpoisuutesi:`,
  please_confirm_that_your_project_is_located_within_or_that_it_benefits_those_within_the_supported_locations: `Vahvista, että projektisi sijaitsee tuetuissa paikoissa tai että se hyödyttää niitä.`,
  please_select: `Ole hyvä ja valitse`,
  project_description: `Projektin kuvaus`,
  please_share_a_summary_of_your_project: `Ole hyvä ja jaa yhteenveto projektistasi`,
  enter_project_summary: `Anna projektin yhteenveto`,
  please_describe_your_project: `Kuvaile projektiasi`,
  for_example_what_do_you_want_to_do: `Esimerkiksi mitä haluat tehdä, miten aiot tehdä tämän, oletko tunnistanut projektin tarpeen ja kuka sitä johtaa?`,
  this_application_is_to: `Tämä sovellus on tarkoitettu:`,
  application_accepted: `Hyväksytyt hakemukset:`,
  application_sections: `Sovellukset osiot`,
  application_preview: `Sovelluksen esikatselu`,
  application_guidance: `Sovellusopastus`,
  in_the_application_form: `Hakulomakkeella sinua pyydetään jakamaan tiedot hankkeesta, jolle haet rahoitusta.`,
  next_title: `"Seuraava"`,
  save_n_exit_title: `"Tallenna ja poistu"`,
  submit_title: `"Lähetä"`,
  saves_your_data_and_moves: `tallentaa tietosi ja siirtää sinut hakemuslomakkeen seuraavaan näyttöön. Vastauksesi tallennetaan automaattisesti, ellei sinulla ole Internet-yhteysongelmia.`,
  saves_your_data_and_closes: `tallentaa tietosi ja sulkee hakulomakkeen, jotta voit palata siihen myöhemmin. Sinun on täytettävä kaikki pakolliset kentät "Tallenna ja poistu" (voit laittaa satunnaisia ​​arvoja, esim. X paikkamerkkinä, cl`,
  saves_your_data_and_closes_the_report: `tallentaa tietosi ja sulkee raportin, jotta voit palata siihen myöhemmin. Sinun on täytettävä kaikki pakolliset kentät "Tallenna ja poistu" varten (voit laittaa satunnaisia ​​arvoja, esim. X paikkamerkkinä)`,
  sends_your_application_form_to_the_company: `lähettää hakemuksesi yritykselle. Tämä painike tulee näkyviin hakulomakkeen viimeiseen näyttöön.`,
  to_access_a_saved_application: `Tallennetun sovelluksen käyttäminen: Napsauta kohtaa Sovellukset ja vaaditaan toimia.`,
  to_view_a_submitted_application: `Lähetetyn hakemuksen tarkasteleminen: Napsauta kohtaa Hakemukset ja odottavat vastaukset`,
  start: `Aloita`,
  application_form: `Hakulomake`,
  your_application: `Sovelluksesi`,
  what_is_the_name_of_your_project: `Mikä on projektisi nimi?`,
  please_complete_each_screen: `Täytä jokainen hakulomakkeen näyttö. Viimeisellä näytöllä näet esikatselun hakemuksestasi ja täältä voit lähettää sen yritykselle napsauttamalla 'Lähetä'.`,
  project_name: `Projektin nimi`,
  add_a_banner_image: `Lisää bannerikuva`,
  this_will_show_at_the_top_of_your_application_form: `Tämä näkyy täytetyn hakulomakkeen yläosassa.`,
  choose_an_image_from_bizGive: `Valitse kuva BizGivestä`,
  upload_your_own_banner_image: `Lataa oma bannerikuvasi`,
  additional_images: `Lisäkuvia`,
  bizGive_images: `BizGive-kuvat`,
  where_is_your_project_located: `Missä projektisi sijaitsee?`,
  search_for_and_select_the_address_of_your_location: `Etsi ja valitse sijaintisi osoite. Tai vaihtoehtoisesti,`,
  click: `napsauta`,
  any_place_or_point_on_the_map_to_select_it: `minkä tahansa paikan tai pisteen kartalla valitaksesi sen.`,
  add_or_Edit_the_name_for_your_location_and_press: `Lisää tai muokkaa sijaintisi nimeä ja lisää paikkoja painamalla Lisää toinen.`,
  add_additional_location: `Lisää lisäsijainti`,
  one_or_more_project_locations_are_located_outside_of_the_programme_area: `Yksi tai useampi hankepaikka sijaitsee ohjelma-alueen ulkopuolella.`,
  please_change_your_project_location_or_explain_how_your_project_will_benefit_the_programme_area_below: `Muuta projektisi sijaintia TAI selitä, kuinka hankkeesi hyödyttää alla olevaa ohjelma-aluetta`,
  how_will_it_benefit_the_programme_area: `Miten se hyödyttää ohjelma-aluetta?`,
  project_dates: `Projektin päivämäärät`,
  when_is_your_project_happening: `Milloin projektisi tapahtuu?`,
  this_can_be_an_estimate: `Tämä voi olla arvio, sillä sinua pyydetään muokkaamaan tai vahvistamaan päivämäärät, jos hakemuksesi onnistuu.`,
  projects_must_start_within_12_months: `Projektien on aloitettava mahdollisuusStartWithinMonths kuukauden kuluessa.`,
  projects_must_not_be_longer_than_6_months: `Projektit eivät saa olla pidempiä kuin optionLengthMonths kuukautta.`,
  estimated_start: `Arvioitu aloitus`,
  estimated_finish: `Arvioitu viimeistely`,
  is_there_a_deadline_when_you_need_to_receive_a_donation_by: `Onko sinulla määräaikaa, jolloin sinun on saatava lahjoitus, jotta projektisi voi edetä?`,
  if_not_please_leave_this_blank: `Jos ei, jätä tämä tyhjäksi.`,
  enter_date: `Anna päivämäärä`,
  what_support_are_you_applying_for: `Mitä tukea haet?`,
  in_kind: `luontoissuorituksina`,
  how_much_are_you_applying_for: `Paljonko haet?`,
  enter_amount: `Anna summa`,
  how_much_does_your_project_cost_in_total: `Kuinka paljon projektisi maksaa yhteensä?`,
  you_are_applying_for_percentage_of_the_total_cost_of_your_project: `Haet prosenttiosuutta projektisi kokonaiskustannuksista`,
  how_will_you_use_any_support_awarded: `Miten aiot käyttää myönnetyn tuen?`,
  enter_number_of_items_or_activity: `Anna kohteiden tai toimintojen määrä`,
  enter_description: `Anna kuvaus`,
  where_will_additional_funds_come_from: `Mistä tulee lisärahoitusta?`,
  internal_resources: `Sisäiset resurssit`,
  external_funding: `Ulkoinen rahoitus`,
  have_you_already_secured_this_funding: `Oletko jo varmistanut tämän rahoituksen?`,
  can_your_project_proceed_if_you: `Voiko projektisi edetä, jos et saa tätä lisärahoitusta?`,
  what_outputs_will_the_support_help_you_to_achieve: `Mitä tuloksia tuki auttaa sinua saavuttamaan?`,
  your_outputs_will_show_like_this_in_your_application_form: `Tuotosi näkyvät hakulomakkeessasi näin:`,
  what_items_or_services_do_you_need: `Mitä tuotteita tai palveluita tarvitset?`,
  for: `varten`,
  what_volunteering_support_do_you_need: `Millaista vapaaehtoistyön tukea tarvitset?`,
  edit_image: `Muokkaa kuvaa`,
  change_image: `Vaihda kuva`,
  delete_image: `Poista kuva`,
  click_delete_to_remove_this_image: `Napsauta "Poista" poistaaksesi tämän kuvan.`,
  option: `Vaihtoehto`,
  add: `Lisätä`,
  tips: `Vinkkejä`,
  what_is_an_output: `Mikä on lähtö?`,
  an_output_is_what_you_expect_to_achieve_from_the_support_awarded_below_are_some_examples: `Tulos on se, mitä odotat saavuttavasi myönnetyltä tuelta. Alla on joitain esimerkkejä:`,
  number_new_teaching_assistants_trained: `5 uutta assistenttia koulutettu`,
  number_new_teachers_trained: `10 uutta opettajaa koulutettu`,
  number_workshops_hosted: `3 työpajaa isännöity`,
  number_energy_audits_completed: `4 energiakatselmusta tehty`,
  number_people_more_aware_of_climate_change_in_our_community: `200 ihmistä on enemmän tietoinen ilmastonmuutoksesta yhteisössämme`,
  number_new_playground_installed: `1 uusi leikkipaikka asennettu`,
  please_enter: `Ole hyvä ja kirjoita`,
  which_of_the_company_impact_objectives_will_your_project_support: `Mitä yrityksen vaikutustavoitteita hankkeesi tukee?`,
  what_outcomes_do_you_hope_your_project_will_achieve: `Mitä tuloksia toivot projektisi saavuttavan?`,
  what_is_an_outcome: `Mikä on tulos?`,
  an_outcome_is_the_change_you_hope_to_see_as_a_result_of_your_project_below_are_some_examples: `Tulos on muutos, jonka toivot näkeväsi projektisi tuloksena. Alla on esimerkkejä.`,
  objective_protect_and_improve_the_local_environment: `Tavoite: Suojella ja parantaa paikallista ympäristöä`,
  outcome_improve_fish_populations_through_river_restoration: `Tulos: Kalakantojen parantaminen jokien ennallistamisen avulla.`,
  objective_create_and_improve_local_amenities: `Tavoite: Luo ja paranna paikallisia palveluita`,
  outcome_improve_the_energy_efficiency_of_the_village_hall_with_new_windows: `Lopputulos: Kylätalon energiatehokkuuden parantaminen uusilla ikkunoilla.`,
  objective_engage_the_local_community: `Tavoite: Ota paikallinen yhteisö mukaan`,
  outcome_reduce_isolation_and_loneliness_in_older_people: `Tulos: Vähentää vanhusten eristäytymistä ja yksinäisyyttä.`,
  how_will_you_achieve_these_outcomes: `Kuinka hankkeenne saavuttaa tulokset?`,
  briefly_describe_your_approach_to_achieving_the_outcomes: `Kuvaile lyhyesti lähestymistapaasi tulosten saavuttamiseen.`,
  below_are_some_examples: `Alla on joitain esimerkkejä:`,
  we_will_remove_excess_silt: `Poistamme ylimääräistä lietettä, jotta kalojen pesimäalueet palautuvat.`,
  we_will_replace_our_old_windows_with_triple_glazed_windows: `Vaihdamme vanhat ikkunamme kolminkertaisiin ikkunoihin.`,
  we_will_run_weekly_workshops_bringing_older_people_together: `Järjestämme viikoittain työpajoja, jotka tuovat vanhuksia yhteen.`,
  how_will_you_achieve_this_outcome: `Miten aiot saavuttaa tämän tuloksen?`,
  please_use_no_more_than_25_words_as_you_will_be_asked_to_describe_your_approach_on_the_next_screen: `Älä käytä enempää kuin 25 sanaa, sillä sinua pyydetään kuvailemaan lähestymistapaasi seuraavassa näytössä.`,
  enter_outcome: `Syötä tulos`,
  please_enter_numeric_value: `Anna numeerinen arvo`,
  expected_decision_date: `Arvioitu päätöksentekopäivä`,
  beneficiaries: `Edunsaajat`,
  who_or_what_will_benefit_from_your_project: `Kuka tai mikä hyötyy projektistasi?`,
  who_are_the_social_beneficiaries: `Mitkä tahot ovat edunsaajia?`,
  select_beneficiary_type: `Valitse Saajan tyyppi`,
  how_many_people_will_benefit: `Kuinka moni hyötyy?`,
  direct_beneficiaries: `Suorat edunsaajat`,
  enter_estimated_number: `Anna arvioitu määrä`,
  indirect_beneficiaries: `Epäsuorat edunsaajat`,
  how_will_the_environment_benefit: `Miten ympäristö hyötyy?`,
  for_example_species_of_new_plants_introduced_ppm_of_CO2_reduced_terrestrial_animals_protected: `Esimerkiksi 10 lajia uusia kasvilajeja, 10 ppm hiilidioksidia vähennetty, 10 maaeläintä suojeltu.`,
  select_type_title: `Valitse Tyyppi`,
  select_sub_type: `Valitse alatyyppi`,
  select_units: `Valitse Yksiköt`,
  your_environmental_beneficiaries_will_show_like_this_in_your_application_form: `Ympäristöedunsaajasi näkyvät hakulomakkeessasi näin:`,
  environmental_beneficiaries: `Ympäristön edunsaajat`,
  the_environmental_beneficiaries_drop_down_fields_enable_you_to_share_additional_details: `Ympäristön edunsaajat -pudotuskenttien avulla voit jakaa lisätietoja, kuten tuetko lajeja, elinympäristöjä tai rakennuksia, kasveja tai eläimiä ja mitä toimia olet tekemässä. `,
  select_type_title_head: `Valitse tyyppi:`,
  choose_whether_your_project_supports_habitats_such_as_forests_or_woodlands: `Valitse, tukeeko projektisi elinympäristöjä, kuten metsiä tai metsiä, lajeja, kuten kasveja tai eläimiä, vai rakennuksia, kuten kouluja tai yhteisiä yhteisörakennuksia, kuten kylätaloa.`,
  select_sub_type_head: `Valitse alatyyppi:`,
  choose_the_type_of_habitat_species_or_building_you_are_supporting: `Valitse elinympäristön, lajin tai rakennuksen tyyppi, jota tuet. Valitse esimerkiksi makea vesi, jos tuet jokia tai järviä.`,
  select_action_head: `Valitse toiminto:`,
  choose_the_type_of_action_you_re_taking_to_support_the_species: `Valitse toiminnan tyyppi, jolla tuet lajia, elinympäristöä tai rakennusta. Valitse esimerkiksi suojeltu, jos suojelet uhanalaisia ​​lajeja, kunnostettu, jos uudistat elinympäristöä`,
  enter_amount_head: `Anna summa:`,
  for_species_estimate_how_many_plants_or_animals_you_re_supporting_through_your_project: `Arvioi lajien osalta, kuinka monta kasvia tai eläintä tuet projektillasi.`,
  for_habitats_estimate_how_many_habitats_you_re_supporting_number_or_the_total_area_in_hectares: `Arvioi elinympäristöjen osalta, kuinka monta elinympäristöä tuet (lukumäärä) tai kokonaispinta-ala (hehtaareina).`,
  for_buildings_estimate_how_many_buildings_you_re_supporting: `Arvioi rakennusten osalta, kuinka monta rakennusta tuet (lukumäärä) tai kuinka paljon vähennät energiaa, vettä tai kasvihuonekaasuja (CO2-ekvivalenttitonnia (CO2e)).`,
  select_units_head: `Valitse yksiköt:`,
  number_is_an_estimate_of_the_total_number_of_habitats_species_or_buildings_you_plan_to_support: `Luku on arvio niiden elinympäristöjen, lajien tai rakennusten kokonaismäärästä, joita aiot tukea.`,
  hectares_is_an_estimate_of_the_total_area_of_a_habitat_youre_supporting: `Hehtaarit on arvio tukemasi elinympäristön kokonaispinta-alasta.`,
  social_beneficiaries: `Sosiaaliset edunsaajat`,
  select_the_type_of_beneficiaries_your_project_supports: `Valitse hankkeesi tukemien edunsaajien tyypit. Arvioi sitten niiden edunsaajien kokonaismäärä, joita aiot tukea kaikissa edunsaajatyypeissä.`,
  direct_beneficiaries_head: `Suorat edunsaajat:`,
  the_number_of_people_who_directly_benefit_from_your_opportunity: `Niiden ihmisten määrä, jotka hyötyvät suoraan mahdollisuudestasi.`,
  indirect_beneficiaries_head: `Välilliset edunsaajat:`,
  the_number_of_people_whose_benefits_can_be_attributed_to_a_direct_beneficiary: `Niiden ihmisten määrä, joiden edut voidaan katsoa suoralle edunsaajalle.`,
  for_example_if_your_project_supports_children_with_learning_disabilitie: `Jos hankkeesi tukee esimerkiksi 10 oppimisvaikeuksista kärsivää lasta, välittömiä edunsaajia ovat 10 lasta. Välillisiä edunsaajia ovat näiden lasten perheet.`,
  habitats: `Elinympäristöt`,
  forest: `Metsä`,
  deserts: `Aavikko`,
  mountains: `Vuori`,
  coastal: `Rannikko`,
  marine: `Meri`,
  freshwater: `Makea vesistö`,
  polar: `Napa-alue`,
  wetlands: `Kosteikot`,
  rainforest: `Sademetsä`,
  arctic: `Arktinen`,
  tundra: `Tundra`,
  restored: `Kunnostetaan`,
  protected: `Suojellaan`,
  created: `Luodaan`,
  hectares: `Hehtaaria`,
  established: `Perustetaan`,
  benefitted: `Hyötyy`,
  terrestrial_animals: `Maaeläimet`,
  aquatic_animals: `Vesieläimet`,
  terrestrial_plants: `Maan kasvit`,
  aquatic_plants: `Vesikasvit`,
  species: `Laji`,
  select_category: `Valitse kategoria`,
  select_sub_category: `Valitse alaluokka`,
  please_add_at_least_one_outcome_under_selected_objectives: `Lisää vähintään yksi tulos valittujen tavoitteiden alle`,
  please_enter_your_approach_for_each_outcome: `Kirjoita lähestymistapasi kullekin tulokselle`,
  create_n_manage_sharing: `Luo ja hallinnoi jakamista`,
  access_closing_date: `Pääsyn sulkemispäivä`,
  please_choose_closing_date: `Valitse sulkemispäivä`,
  newly_invited_users_will_receive_an_email_invitation: `Äskettäin kutsutut käyttäjät saavat sähköpostikutsun.`,
  existing_invited_users_will_not_be_notified_of_changes: ` Olemassa oleville kutsutuille käyttäjille ei ilmoiteta muutoksista.`,
  update: `Päivittää`,
  user_already_exists: `Käyttäjä on jo olemassa`,
  verify_your_email: `Vahvista sähköpostiosoitteesi`,
  please_verify_your_email_to_receive_a_magic_link: `Vahvista sähköpostiosoitteesi saadaksesi taikalinkin, jolla pääset palauteportaaliisi.`,
  emissions: `Päästöt`,
  greenhouse_gases: `Kasvihuonekaasut`,
  reduced: `Vähennetty`,
  captured: `Vangittu`,
  prevented: `Estetty`,
  tonnes_of_CO2_equivalents_C02e: `CO2-ekvivalenttitonnia (C02e)`,
  additional_questions: `Lisäkysymyksiä`,
  required_documents: `Vaaditut asiakirjat`,
  additional_files: `Lisätiedostot`,
  document_name: `Asiakirjan nimi`,
  custom_question: `Mukautettu kysymys?`,
  custom_questions: `Mukautetut kysymykset`,
  enter_answer: `Anna vastaus`,
  if_you_are_awarded_support_you_may_be_required_to_share_interim_Updates: `Jos saat tukea, saatat joutua jakamaan välipäivitykset ja kertaluonteisen loppuraportin yritykselle. Saat BizGiveltä sähköposti-ilmoituksen, jos ja kun ne ovat erääntyneet.`,
  can_you_meet_the_required_submission_deadlines: `Pystytkö noudattamaan vaadittuja toimitusaikoja?`,
  based_on_the_estimated_start_and_finish_date_of_your_project: `Vahvista hankkeesi arvioidun aloitus- ja päättymispäivämäärän perusteella, että pystyt noudattamaan alla olevia toimitusaikoja. Voit päivittää projektisi päivämäärät, jos hakemuksesi on n`,
  interim_updates: `Väliaikapäivitykset`,
  final_report: `Loppuraportti`,
  this_value_cannot_be_lower_than_the_amount_you_are_applying_for: `Tämä arvo ei voi olla pienempi kuin hakemasi summa`,
  what_is_an_interim_update: `Mikä on välipäivitys?`,
  an_update_required_by_the_company_on_the_progress_of_your_project: `Yrityksen vaatima päivitys projektisi edistymisestä.`,
  download_interim_update_report_template: `Lataa välipäivitysraporttimalli`,
  what_is_a_final_report: `Mikä on loppuraportti`,
  a_single_report_required_by_the_company_on_what_your_project_achieved_with_the_support_provided: `Yrityksen vaatima yksittäinen raportti siitä, mitä hankkeesi on saavuttanut saamasi tuella.`,
  download_final_report_template: `Lataa loppuraporttimalli`,
  how_will_i_know_when_an_interim_update_or_final_report_is_due: `Mistä tiedän, milloin välipäivitys tai loppuraportti on määrä tehdä?`,
  you_will_receive_an_email_notification_from_bizGive_when_the_deadline_is_approaching: `Saat BizGiveltä sähköposti-ilmoituksen, kun määräaika lähestyy. Noudata näissä sähköpostiviesteissä olevia ohjeita täyttääksesi ja lähettääksesi nämä raportit yritykselle.`,
  contact_details: `Yhteystiedot`,
  after_submitting_your_application_you_will_receive_email_notifications_from_BizGive_on_its_status: `Kun olet lähettänyt hakemuksesi, saat BizGiveltä sähköposti-ilmoitukset sen tilasta.`,
  please_add_another_contact_in_case_of_your_absence: `Ole hyvä ja lisää toinen yhteyshenkilö, jos et ole poissa.`,
  if_theyre_already_on_BizGive_select_their_name_below: `Jos he ovat jo BizGivessä, valitse heidän nimensä alta:`,
  invite_a_colleague_to_join_by_entering_their_email_address_below: `Kutsu kollegasi mukaan antamalla hänen sähköpostiosoitteensa alle:`,
  select_user: `Valitse Käyttäjä`,
  what_is_an_indicator: `Mikä on indikaattori?`,
  an_indicator_is_a_measure_of_progress: `Indikaattori on edistymisen mitta. Se sisältää tavoitteen ja virstanpylväät tämän tavoitteen saavuttamiseksi. Esimerkiksi ihmisten lukumäärä, joita aiot auttaa, ja kuinka tämä lisääntyy ajan myötä.`,
  an_indicator_is_an_estimate: `Indikaattori on arvio, joten älä huoli, jos suunnitelmasi muuttuvat. Jos hakemuksesi hyväksytään, sinua pyydetään päivittämään indikaattorisi.`,
  indicator_examples: `Esimerkkejä indikaattoreista`,
  no_of_people_gaining_a_new_skill_or_qualification: `Uutta taitoa tai pätevyyttä hankkivien ihmisten lukumäärä`,
  no_of_workshops_hosted: `Järjestettyjen työpajojen lukumäärä`,
  decrease_in_local_unemployment: `Paikallinen työttömyys väheni %`,
  when_do_i_update_my_indicators: `Milloin päivitän indikaattorini?`,
  if_your_application_is_approved: `Jos hakemuksesi hyväksytään, saat sähköposti-ilmoituksia BizGiveltä, kun sinun on päivitettävä indikaattorisi.`,
  how_often_do_I_update_my_indicators: `Kuinka usein päivitän indikaattorini?`,
  you_will_be_asked_to_update_your_indicators_at_the_same_time: `Sinua pyydetään päivittämään indikaattorisi samaan aikaan, kun sinua pyydetään lähettämään välipäivitys tai loppuraportti.`,
  measuring_progress: `Edistyksen mittaaminen`,
  objective_outcome_specific_indicators: `Tavoite-/tuloskohtaiset indikaattorit`,
  mandatory_title: `Pakollinen`,
  about_your_project: `Tietoja projektistasi`,
  your_request: `Pyyntösi`,
  planned_impact_title: `Suunniteltu vaikutus`,
  award_criteria: `Palkintokriteerit`,
  step_1: `Vaihe 1`,
  step_2: `Vaihe 2`,
  step_3: `Vaihe 3`,
  step_4: `Vaihe 4`,
  step_5: `Vaihe 5`,
  submit_your_application: `Lähetä hakemuksesi`,
  to_submit_your_application_you_must_read_and_agree_to_the_application: `Lähettääksesi hakemuksesi sinun tulee lukea hakemus ja hyväksyä se`,
  terms_and_conditions: `Ehdot`,
  below: `alla.`,
  please_note_you_will_not_be_able_to_edit_your_application_after_it_has_been_submitted_unless_requested_to_by_the_company_youre_applying_to: `Huomaa, että et voi muokata hakemustasi sen lähettämisen jälkeen, ellei yritys, johon haet, niin pyydä.`,
  by_submitting_this_application_you_will_be_sharing_your_application_user_details_and_ongoing_entity_profile_information_with_the_funder: `Lähettämällä tämän hakemuksen jaat hakemuksesi, käyttäjätietosi ja voimassa olevat yhteisöprofiilisi tiedot rahoittajan kanssa.`,
  enter_caption: `Kirjoita kuvateksti...`,
  impact_alignment: `Hankkeen vaikutusten määrittely`,
  approve: `Hyväksyä`,
  decline: `Hylkää`,
  requested_support: `Pyydetty tuki`,
  total_request: `Pyyntö yhteensä`,
  total_project_budget: `Projektin kokonaisbudjetti`,
  funder_contribution: `Rahoittajan panos`,
  planned_expenditure: `Suunnitellut menot`,
  additional_funding: `Lisärahoitus`,
  additional_funding_is_required_to_meet_the_total_opportunity_budget: `Lisärahoitusta tarvitaan mahdollisuuksien kokonaisbudjetin kattamiseksi`,
  where_will_additional_funds_be_sourced: `Mistä hankitaan lisärahoitusta?`,
  has_this_funding_been_secured: `Onko tämä loppurahoitus turvattu?`,
  can_this_project_go_ahead_without_additional_funding: `Voiko hanke jatkua ilman lisärahoitusta?`,
  outputs: `Lähdöt`,
  you_must_select_yes_to_proceed: `Sinun on valittava Kyllä jatkaaksesi`,
  please_enter_the_dates_within_the_above_mentioned_limits: `Anna päivämäärät yllä mainittujen rajojen sisällä`,
  at_least_one_checkbox_must_be_selected: `Vähintään yksi valintaruutu on valittava`,
  delete_confirmation: `Poista vahvistus`,
  unchecking_this_box_will_delete_any_underlying_data_you_have_entered_for_this_objective_or_outcome: `Tämän ruudun valinnan poistaminen poistaa kaikki tälle tavoitteelle tai tulokselle antamasi taustatiedot.`,
  at_least_one_outcome_must_be_selected: `Vähintään 1 tulos on valittava`,
  please_select_at_least_one_objective: `Valitse vähintään 1 tavoite`,
  project_timelines: `Projektin aikajanat`,
  project_location: `Projektin sijainti`,
  pending_title: `Odottaa`,
  view_indicator: `Näytä ilmaisin`,
  indicators_status_confirmation: `Ilmaisimien tila Vahvistus`,
  indicators_successfully_submitted: `Indikaattorit lähetetty onnistuneesti`,
  please_create_at_least_indicator_outcome: `Luo vähintään yksi indikaattori tulosta kohden`,
  please_complete_n_delete_pending_indicators: `Täydennä tai poista odottavat indikaattorit`,
  modal_will_be_closed_after_two_seconds: `Modaali sulkeutuu kahden sekunnin kuluttua`,
  please_enter_indicatorInterimActual: `Anna indikaattoriInterimActual`,
  no_comments: `Ei kommentteja`,
  enter_final_total: `Syötä lopullinen summa`,
  milestone_date: `Virstanpylväspäivämäärä`,
  accumulative_target: `Kertyvä tavoite`,
  actuals: `Tosiasiat`,
  evidence: `Todisteet`,
  total_target: `Kokonaistavoite`,
  please_enter_total_accumulative_target: `Anna kertynyt kokonaistavoite`,
  please_add_value_for_historic_milestone: `Lisää arvo jokaiselle historialliselle virstanpylvälle`,
  cancel_uppercase: `PERUUTTAA`,
  submit_uppercase: `LÄHETÄ`,
  press_submit_to_confirm: `Vahvista syöttämäsi painamalla Lähetä. Huomaa, että tämä jaetaan`,
  confirmation: `Vahvistus`,
  your_donor_n_can_not_be_edited: `lahjoittajasi, eikä sitä voi muokata`,
  indicator_name: `Ilmaisimen nimi`,
  please_enter_indicator_name: `Anna indikaattorin nimi`,
  main_focus: `Pääpainopiste`,
  social_n_beneficiaries: `Sosiaaliset / Edunsaajat`,
  please_select_beneficiaries: `Valitse edunsaajat`,
  please_enter_unit: `Anna yksikkö`,
  how_will_you_measure_progress: `Miten mittaat edistymistä?`,
  starting_number_level_indicator: `Indikaattorisi aloitusnumero/taso`,
  if_you_do_not_know_this_then_enter_zero: `Jos et tiedä tätä, kirjoita 0`,
  target_number_or_level_reach: `Tavoitenumero tai tavoitetaso`,
  target_we_aim_to_reach_is: `Tavoite, johon pyrimme, on`,
  from_starting_number_n_level: `lähtönumerosta/tasosta`,
  estimate_what_change_starting_para: `Valinnainen: Arvioi, mikä muutos aloitusnumerossa/tasossa olisi mahdollisuuksien aikajanasi loppuun mennessä, jos et puuttuisi asiaan?`,
  your_total_effort_will_be: `Kokonaisponnistuksenne tulee olemaan`,
  taking_account_you_did_not_intervene: `ottaa huomioon, mitä tapahtuisi, jos et puuttuisi asiaan`,
  how_will_you_gather_evidence: `Miten aiot kerätä todisteita?`,
  please_enter_details: `Anna tiedot`,
  evidence_verification_method: `Todisteiden varmistusmenetelmä`,
  your_contribution: `Oma panoksesi`,
  measuring_your_impact: `Vaikutuksen mittaaminen`,
  to_measure_the_progress_of_your_opportunity: `Yritys on pyytänyt sinua lisäämään indikaattoreita mahdollisuutesi edistymisen mittaamiseksi. Indikaattorien avulla voit asettaa arvioituja tavoitteita ja virstanpylväitä niiden saavuttamiseksi.`,
  opportunity_indicators: `Mahdollisuuksien indikaattorit`,
  these_indicators_are_general_to_your_opportunity_or_entity: `Nämä indikaattorit koskevat mahdollisuuttasi tai kokonaisuuttasi. Luo ne napsauttamalla Lisää.`,
  these_indicators_support_the_specific_objectives_and_outcomes: `Nämä indikaattorit tukevat mahdollisuutesi erityisiä tavoitteita ja tuloksia. Luo ne napsauttamalla Lisää`,
  describe_the_starting_situation: `Kuvaile aloitustilannetta:`,
  describe_the_final_situation: `Kuvaa haluttu lopputilanne:`,
  describe_the_final_title_situation: `Kuvaile haluttua lopputilannetta:`,
  please_confirm_that_you_can_provide_any_of_following_evidence_items: `Vahvista, että voit toimittaa seuraavat todisteet`,
  starting_number_level_of_your_indicator: `Indikaattorisi aloitusnumero`,
  target_number_or_level_to_reach: `Tavoitenumero tavoittaa`,
  estimate_what_the_change_in_the_starting_number: `Valinnainen: Arvioi, mikä muutos aloitusnumerossa/tasossa olisi mahdollisuuksien aikajanasi loppuun mennessä, jos et puuttuisi asiaan?`,
  the_target_we_aim_to_reach_is_employed_from_the_starting_number_level: `Tavoite, johon pyrimme, on työllistettyTyöllisten määrä lähtönumerosta/tasosta`,
  your_total_impact_will_be_employed: `Kokonaisvaikutuksesi on ImpactNumber työllistetty`,
  your_final_absolute_change_is_impactNumber: `Viimeinen absoluuttinen muutoksesi on ImpactNumber`,
  your_final_relative_change_is_impactNumber: `Viimeinen suhteellinen muutoksesi on ImpactNumber`,
  we_will_aim_for_sample_size_of_individuals: `Pyrimme 20 henkilön otokseen...`,
  restrict_applications_to_within_certain_radius_of_this_location: `Rajataanko sovellukset tietylle säteelle tästä sijainnista?`,
  enter_number: `Syötä numero`,
  biannually: `Puolivuosittain`,
  please_select_your_impact_strategy: `Valitse vaikutusstrategiasi`,
  reporting_requirements: `Raportointivaatimukset`,
  starting: `Alkaa`,
  create_indicator: `Luo indikaattori`,
  optional_title: `Valinnainen`,
  optional_head: `Valinnainen?`,
  estimate_what_the_level_would_be: `Arvioi mikä muutos aloitusnumerossa olisi projektisi päättymispäivään mennessä, jos et puuttuisi asiaan? (lisää +/- merkki)`,
  this_value_cannot_be_more_than_the_amount_you_are_applying_for: `Tämä arvo ei voi olla suurempi kuin hakemasi summa`,
  you_must_apply_for_100_percentage_of_the_total_project_cost: `Sinun tulee hakea 100 % projektin kokonaiskustannuksista`,
  please_save_a_location: `Tallenna sijainti`,
  i_agree: `Olen samaa mieltä`,
  project_running_dates: `Projektien toteutuspäivät`,
  donations_required_before: `Lahjoitukset vaaditaan ennen`,
  add_programme: `Lisää ohjelma`,
  budget_end_date: `Budjetin päättymispäivä`,
  application_window: `Sovellusikkuna`,
  choose_either_option: `Valitse jompikumpi vaihtoehto:`,
  copy_an_existing_programme: `Kopioi olemassa oleva ohjelma`,
  create_a_new_programme: `Luo uusi ohjelma`,
  what_is_the_name_of_your_programme: `Mikä on ohjelmasi nimi?`,
  what_is_the_area_of_impact: `Mikä on vaikutusalue?`,
  projects_or_impact_must_be_within: `Projektien tai vaikutusten on oltava seuraavissa rajoissa:`,
  a_custom_area: `Mukautettu alue`,
  an_administrative_boundary_eg_a_council_area_or_country: `Hallinnollinen raja mm. neuvoston alue tai maa.`,
  a_certain_distance_from_a_point: `Tietty etäisyys pisteestä.`,
  click_on_the_map_to_start_drawing_your_area: `Napsauta karttaa aloittaaksesi alueen piirtämisen, kaksoisnapsauta viimeistelläksesi sen. Voit tarvittaessa poistaa sen kartan alla olevasta alueen nimi -vaihtoehdosta napsauttamalla poistokuvaketta -kohdan oikealla puolella`,
  use_the_search_box_to_find_administrative_boundaries: `Käytä hakukenttää löytääksesi hallinnolliset rajat. Tarkastele rajaa napsauttamalla nimeä, valitse raja napsauttamalla 'Valitse'. Poista alueita tai muokkaa nimiä alueen nimi -osiosta alla `,
  click_on_the_map_to_add_a_point: `Napsauta karttaa lisätäksesi pisteen, anna sitten sallittu säde alle ja paina "Luo alue" näyttääksesi alueen kartalla. Aloita uudelleen napsauttamalla karttaa lisätäksesi uuden pisteen.`,
  what_is_the_area_called: `Mikä on alueen nimi?`,
  programme_details: `Ohjelman tiedot`,
  write_a_short_summary_of_your_programme: `Kirjoita lyhyt yhteenveto ohjelmastasi`,
  write_a_longer_description: `Kirjoita pidempi kuvaus`,
  do_you_wish_to_share_any_supporting_material: `Haluatko jakaa tukimateriaalia?`,
  select_all_options: `Valitse kaikki vaihtoehdot`,
  indicators: `Indikaattorit`,
  details: `Yksityiskohdat`,
  programme_support: `Ohjelmatuki`,
  what_support_can_you_offer: `Mitä tukea voit tarjota?`,
  what_is_your_budget: `Mikä on budjettisi`,
  make_this_budget_amount_visible_in_your_programme_as_an_estimated_budget: `Tee tästä budjettisummasta näkyväksi ohjelmassasi "arvioitu budjetti"`,
  is_there_a_limit_donation_amount_per_project: `Onko projektikohtaista lahjoituksen rajaa?`,
  projects_must_be_fully_funded_by_you_without_additional_third_party_funding: `Sinun on rahoitettava hankkeet kokonaan ilman ylimääräistä kolmannen osapuolen rahoitusta`,
  does_this_budget_recur: `Toistuuko tämä budjetti?`,
  per_project: `Projektia kohti`,
  no_it_is_fixed: `Ei, se on korjattu.`,
  yes_annual_starting_on: `Kyllä, vuosittain alkaen:`,
  please_include_in_your_invoice_the_following_details: `Liitä laskuun seuraavat tiedot...`,
  share_any_invoice_instructions_for_approved_grantees_to_view: `Jaa kaikki laskun ohjeet hyväksyttyjen apurahan saajien nähtäväksi`,
  do_you_want_to_upload_an_invoice_template_for_approved_applicants_to_use: `Haluatko ladata laskumallin hyväksyttyjen hakijoiden käytettäväksi?`,
  what_type_of_volunteering_can_you_offer: `Millaista vapaaehtoistyötä voit tarjota?`,
  what_skilled_volunteering_is_available: `Mitä ammattitaitoista vapaaehtoistyötä on tarjolla?`,
  start_date: `Aloituspäivämäärä`,
  end_date: `Päättymispäivämäärä`,
  general: `Kenraali`,
  skilled: `Taitava`,
  skill: `Taito`,
  number_of_item_service: `Numero (tuote/palvelu)`,
  item_service_description: `Tuotteen/palvelun kuvaus`,
  what_type_of_in_kind_support_can_you_offer: `Millaista luontoissuoritusta voit tarjota?`,
  timelines: `Aikajanat`,
  when_are_you_accepting_applications: `Milloin otat hakemuksia vastaan?`,
  a_date_range: `Ajanjakso`,
  ongoing: `Meneillään`,
  when_are_application_decisions_made: `Milloin hakupäätökset tehdään?`,
  periodically: `Määräajoin`,
  when_do_you_expect_to_make_donations: `Milloin aiot tehdä lahjoituksia?`,
  do_you_want_to_restrict_project_timelines: `Haluatko rajoittaa projektin aikajanaa?`,
  projects_must_start_within: `Projektit on aloitettava sisällä`,
  projects_must_not_be_longer_than: `Projektit eivät saa olla pidempiä kuin`,
  months: `kuukautta`,
  eligible_entities: `Tukikelpoiset kokonaisuudet`,
  what_type_of_entity_is_able_to_apply_to_your_programme: `Millainen taho voi hakea ohjelmaasi?`,
  please_select_all_that_apply_below: `Valitse alta kaikki sopivat.`,
  uk: `Iso-Britannia`,
  international: `Kansainvälinen`,
  applicants_must_agree_to_these_before_applying: `Hakijoiden on hyväksyttävä nämä ennen hakemuksen jättämistä`,
  entity_project_must_be: `Kokonaisuuden/projektin on oltava...`,
  application_questions: `Sovelluskysymykset`,
  do_you_want_to_add_any_custom_application_questions: `Haluatko lisätä mukautettuja sovelluksia koskevia kysymyksiä?`,
  word_limit: `Sanarajoitus`,
  question: `Kysymys`,
  please_enter_your_application_terms_and_conditions: `Kirjoita hakemuksesi ehdot`,
  we_ask_all_applicants_to_approve_this_before_submitting_their_application: `Pyydämme kaikkia hakijoita hyväksymään tämän ennen hakemuksen jättämistä.`,
  please_enter_a_link_to_your_privacy_policy: `Anna linkki tietosuojakäytäntöösi`,
  we_ask_all_applicants_to_acknowledge_this_before_submitting_their_application: `Pyydämme kaikkia hakijoita vahvistamaan tämän ennen hakemuksen jättämistä.`,
  measuring_impact: `Vaikutuksen mittaaminen`,
  when_do_you_want_to_receive_interim_updates: `Milloin haluat vastaanottaa välipäivityksiä?`,
  recurring_to_project_dates: `Toistuu projektin päivämääriin`,
  not_required: `Ei vaadita`,
  every: `Joka`,
  days_between_project_start_and_end_dates: `Päivät projektin alkamis- ja päättymispäivän välillä`,
  when_do_you_want_to_receive_a_final_report: `Milloin haluat saada loppuraportin?`,
  relative_to_project_dates: `Suhteessa projektin päivämääriin`,
  days_after_the_project_end_date: `Päiviä projektin päättymispäivän jälkeen`,
  are_there_any_additional_questions_you_would_like_to_ask_in_the_final_report: `Onko loppuraportissa lisäkysymyksiä?`,
  do_you_want_additional_legal_terms_for_entities_to_accept_on_submission_of_reports_to_you: `Haluatko, että yhteisöt hyväksyvät lisäoikeudellisia ehtoja toimittaessaan sinulle raportteja?`,
  programme_administration: `Ohjelman hallinto`,
  internal_approval_steps: `Sisäisen hyväksynnän vaiheet`,
  approval_step: `Hyväksymisvaihe`,
  voting: `Äänestäminen`,
  scoring_category: `Pisteytysluokka`,
  create_the_categories_that_you_would_like_to_evaluate_applications_against: `Luo luokat, joihin haluat arvioida hakemuksia esim. "vastinetta rahalle" tai "kokonaisvaikutus"`,
  insert: `Lisää`,
  scoring_category_options: `Pisteytysluokkavaihtoehdot`,
  detail_the_category_options_available_to_be_selected_for_the_above_categories: `Tarkenna yllä oleviin luokkiin valittavia luokkavaihtoehtoja kunkin vaihtoehdon "numeerisella arvolla", jotta lopullinen pistemäärä voidaan laskea. Voit myös halutessasi lisätä kuvauksen`,
  list_the_scoring_category_options_with_a_value_and_an_optional_description: `Listaa pisteytysluokkavaihtoehdot arvolla ja valinnaisella kuvauksella. Arvo voi olla esimerkiksi "1" ja kuvaus "Matala" tai arvo "3" ja kuvaus "Korkea".`,
  numerical_value: `Numeerinen arvo`,
  optional_description: `Valinnainen kuvaus`,
  who_will_manage_this_programme: `Kuka hallinnoi tätä ohjelmaa?`,
  managers_can_edit_the_programme_interact_with_applicants_approve_applications_and_receive_related_email_notifications: `Esimiehet voivat muokata ohjelmaa, olla vuorovaikutuksessa hakijoiden kanssa, hyväksyä hakemuksia ja vastaanottaa niihin liittyviä sähköposti-ilmoituksia.`,
  who_can_view_this_programme: `Kuka voi katsella tätä ohjelmaa`,
  viewers_can_view_the_programme_and_applications_but_not_edit_the_programme: `Katsojat voivat tarkastella ohjelmaa ja hakemuksia, mutta eivät muokata ohjelmaa, olla vuorovaikutuksessa hakijoiden kanssa, hyväksyä hakemuksia tai vastaanottaa niihin liittyviä sähköposti-ilmoituksia.`,
  programme_visibility: `Ohjelman näkyvyys`,
  bizGive_open: `BizGive (avoin)`,
  any_charity_signed_up_to_bizGive_can_view_and_apply_to_your_programme: `Kaikki BizGiveen rekisteröityneet hyväntekeväisyysjärjestöt voivat tarkastella ohjelmaasi ja hakea siihen.`,
  bizGive_invite_only: `BizGive (vain kutsu)`,
  only_charities_you_invite_to_apply_to_your_programme_can_view_it: `Vain hyväntekeväisyysjärjestöt, jotka olet kutsunut hakemaan ohjelmaasi, voivat nähdä sen.`,
  public_open: `Julkinen (avoin)`,
  your_programme_will_have_its_own_link_and_branded_landing_page_on_bizGive: `Ohjelmallasi on oma linkkinsä ja brändätty aloitussivu BizGivessä, joten voit jakaa sen missä tahansa alustan ulkopuolella. Kaikki BizGiveen rekisteröityneet hyväntekeväisyysjärjestöt voivat myös tarkastella ja hakea.`,
  public_invite_only: `Julkinen (vain kutsu)`,
  your_programme_will_have_its_own_link_and_branded_landing_page_on_bizGive_invite_them_to_apply: `Ohjelmallasi on oma linkkinsä ja brändätty aloitussivu BizGivessä, joten voit jakaa sen missä tahansa alustan ulkopuolella. Se ei näy BizGiveen rekisteröityneille hyväntekeväisyysjärjestöille, ellet kirjaudu sisään`,
  add_a_custom_programme_url: `Lisää mukautettu ohjelman URL-osoite`,
  publish_your_programme: `Julkaise ohjelmasi`,
  this_will_make_your_programme_visible_as_per_your_visibility_settings: `Tämä tekee ohjelmastasi näkyvän näkyvyysasetustesi mukaisesti.`,
  you_can_still_edit_all_details_of_the_programmes_after_publishing: `Voit silti muokata kaikkia ohjelmien tietoja julkaisun jälkeen.`,
  required_document_name: `Pakollinen asiakirjan nimi`,
  change: `Muuttaa`,
  number_of_days: `Päivien lukumäärä`,
  programme_approval: `Ohjelman hyväksyntä`,
  there_must_be_at_least_1_votingScoreCriteria_added: `Vähintään 1 votingScoreCriteria on lisättävä`,
  there_must_be_at_least_1_votingCriteriaOptions_added: `Vähintään 1 votingCriteriaOptions on lisättävä`,
  publish: `Julkaista`,
  confirm: `Vahvistaa`,
  project_timeline: `Projektin aikajana`,
  company: `Yritys`,
  this_programme_is_closing_in_number_days: `Tämä ohjelma päättyy päivien kuluttua`,
  this_programme_is_now_closed: `Tämä ohjelma on nyt suljettu`,
  the_application_window_is: `Sovellusikkuna on`,
  login_or_signup_into_bizGive_to_discover_new_funding_programmes: `Kirjaudu sisään tai rekisteröidy BizGiveen löytääksesi uusia rahoitusohjelmia.`,
  discover_more_programmes: `Tutustu lisää ohjelmiin`,
  end: `Loppu`,
  to_apply_to_the: `Voit hakea`,
  log_in_or_sign_up_to_create_your_free_bizGive_account: `Kirjaudu sisään tai rekisteröidy luodaksesi ilmainen BizGive-tili.`,
  if_youre_new_to_BizGive_create_an_organisation_profile: `Jos olet uusi BizGive-käyttäjä, luo organisaatioprofiili.`,
  complete_your_application_to_the_programme: `Täytä hakemuksesi ohjelmaan.`,
  receive_alerts_when_action_is_required_or_a_funding_decision_is_made: `Saat hälytyksiä, kun toimia tarvitaan tai rahoituspäätös on tehty.`,
  apply_to_other_programmes_from_the_discover_section: `Hae muihin ohjelmiin Discover-osiosta.`,
  entity_location: `Kokonaisuuden sijainti`,
  which_country_must_entities_be_located_in_leave_blank_if_any_are_accepted: `Missä maassa yksiköiden on sijaittava? Jätä tyhjäksi, jos hyväksytään`,
  search_country: `Hae maata`,
  please_select_country: `Valitse maa`,
  your_requested_amount_exceeds_the_programme_limit: `Pyytämäsi summa ylittää ohjelman rajan`,
  your_requested_amount_is_lower_than_the_programme_limit: `Pyytämäsi summa on pienempi kuin ohjelmaraja`,
  your_requested_amount_does_not_equal_the_programme_limit: `Pyytämäsi summa ei ole sama kuin ohjelman raja`,
  isLocal: `On Paikallinen`,
  submission_date: `Lähetyspäivämäärä: `,
  local_within_km: `Paikallinen arvo km`,
  group_by_visitor: `Ryhmittele vierailijan mukaan`,
  local_only: `Vain paikallinen`,
  within_km: `Arvon sisällä km`,
  maximum_grant_size: `Apurahan enimmäiskoko`,
  minimum_grant_size: `Apurahan vähimmäiskoko`,
  none_required: `Ei vaadita`,
  outcome_title: `Tulokset:`,
  consolidated_report: `Konsolidoitu kertomus`,
  portfolio: `Portfolio`,
  portfolio_name: `Portfolion nimi`,
  period: `Kausi`,
  grant_size: `Apurahan koko`,
  afghanistan: `Afganistan`,
  albania: `Albania`,
  algeria: `Algeria`,
  andorra: `Andorra`,
  angola: `Angola`,
  antigua_and_barbuda: `Antigua ja Barbuda`,
  argentina: `Argentiina`,
  armenia: `Armenia`,
  australia: `Australia`,
  austria: `Itävalta`,
  azerbaijan: `Azerbaidžan`,
  bahrain: `Bahrain`,
  bangladesh: `Bangladesh`,
  barbados: `Barbados`,
  belarus: `Valko-Venäjä`,
  belgium: `Belgia`,
  belize: `Belize`,
  benin: `Benin`,
  bhutan: `Bhutan`,
  bolivia: `Bolivia`,
  bosnia_and_herzegovina: `Bosnia ja Hertsegovina`,
  botswana: `Botswana`,
  brazil: `Brasilia`,
  brunei: `Brunei`,
  bulgaria: `Bulgaria`,
  burkina_faso: `Burkina Faso`,
  burundi: `Burundi`,
  cambodia: `Kambodža`,
  cameroon: `Kamerun`,
  canada: `Kanada`,
  cape_verde: `Kap Verde`,
  central_african_republic: `Keski-Afrikan tasavalta`,
  chad: `Tšad`,
  chile: `Chile`,
  china: `Kiina`,
  colombia: `Kolumbia`,
  comoros: `Komorit`,
  congo: `Kongo`,
  congo_democratic_republic: `Kongo (demokraattinen tasavalta)`,
  costa_rica: `Costa Rica`,
  croatia: `Kroatia`,
  cuba: `Kuuba`,
  cyprus: `Kypros`,
  czechia: `Tšekki`,
  denmark: `Tanska`,
  djibouti: `Djibouti`,
  dominica: `Dominica`,
  dominican_republic: `Dominikaaninen tasavalta`,
  east_timor: `Itä-Timor`,
  ecuador: `Ecuador`,
  egypt: `Egypti`,
  el_salvador: `El Salvador`,
  equatorial_guinea: `Päiväntasaajan Guinea`,
  eritrea: `Eritrea`,
  estonia: `Viro`,
  eswatini: `Eswatini`,
  ethiopia: `Etiopia`,
  fiji: `Fidži`,
  finland: `Suomi`,
  france: `Ranska`,
  gabon: `Gabon`,
  georgia: `Georgia`,
  germany: `Saksa`,
  ghana: `Ghana`,
  greece: `Kreikka`,
  grenada: `Grenada`,
  guatemala: `Guatemala`,
  guinea: `Guinea`,
  guinea_bissau: `Guinea-Bissau`,
  guyana: `Guyana`,
  haiti: `Haiti`,
  honduras: `Honduras`,
  hungary: `Unkari`,
  iceland: `Islanti`,
  india: `Intia`,
  indonesia: `Indonesia`,
  iran: `Iran`,
  iraq: `Irak`,
  ireland: `Irlanti`,
  israel: `Israel`,
  italy: `Italia`,
  ivory_coast: `Norsunluurannikko`,
  jamaica: `Jamaika`,
  japan: `Japani`,
  jordan: `Jordania`,
  kazakhstan: `Kazakstan`,
  kenya: `Kenia`,
  kiribati: `Kiribati`,
  kosovo: `Kosovo`,
  kuwait: `Kuwait`,
  kyrgyzstan: `Kirgisia`,
  laos: `Laos`,
  latvia: `Latvia`,
  lebanon: `Libanon`,
  lesotho: `Lesotho`,
  liberia: `Liberia`,
  libya: `Libya`,
  liechtenstein: `Liechtenstein`,
  lithuania: `Liettua`,
  luxembourg: `Luxemburg`,
  madagascar: `Madagaskar`,
  malawi: `Malawi`,
  malaysia: `Malesia`,
  maldives: `Malediivit`,
  mali: `Mali`,
  malta: `Malta`,
  marshall_islands: `Marshallin saaret`,
  mauritania: `Mauritania`,
  mauritius: `Mauritius`,
  mexico: `Meksiko`,
  federated_states_of_micronesia: `Mikronesian liittovaltiot`,
  moldova: `Moldova`,
  monaco: `Monaco`,
  mongolia: `Mongolia`,
  montenegro: `Montenegro`,
  morocco: `Marokko`,
  mozambique: `Mosambik`,
  myanmar_burma: `Myanmar (Burma)`,
  namibia: `Namibia`,
  nauru: `Nauru`,
  nepal: `Nepal`,
  netherlands: `Alankomaat`,
  new_zealand: `Uusi-Seelanti`,
  nicaragua: `Nicaragua`,
  niger: `Niger`,
  nigeria: `Nigeria`,
  north_korea: `Pohjois-Korea`,
  north_macedonia: `Pohjois-Makedonia`,
  norway: `Norja`,
  oman: `Oman`,
  pakistan: `Pakistan`,
  palau: `Palau`,
  panama: `Panama`,
  papua_new_guinea: `Papua-Uusi-Guinea`,
  paraguay: `Paraguay`,
  peru: `Peru`,
  philippines: `Filippiinit`,
  poland: `Puola`,
  portugal: `Portugali`,
  qatar: `Qatar`,
  romania: `Romania`,
  russia: `Venäjä`,
  rwanda: `Ruanda`,
  st_kitts_and_nevis: `St Kitts ja Nevis`,
  st_lucia: `St Lucia`,
  st_vincent: `St Vincent`,
  samoa: `Samoa`,
  san_marino: `San Marino`,
  sao_tome_and_principe: `São Tome ja Principe`,
  saudi_arabia: `Saudi-Arabia`,
  senegal: `Senegal`,
  serbia: `Serbia`,
  seychelles: `Seychellit`,
  sierra_leone: `Sierra Leone`,
  singapore: `Singapore`,
  slovakia: `Slovakia`,
  slovenia: `Slovenia`,
  solomon_islands: `Salomonsaaret`,
  somalia: `Somalia`,
  south_africa: `Etelä-Afrikka`,
  south_korea: `Etelä-Korea`,
  south_sudan: `Etelä-Sudan`,
  spain: `Espanja`,
  sri_lanka: `Sri Lanka`,
  sudan: `Sudan`,
  suriname: `Suriname`,
  sweden: `Ruotsi`,
  switzerland: `Sveitsi`,
  syria: `Syyria`,
  tajikistan: `Tadžikistan`,
  tanzania: `Tansania`,
  thailand: `Thaimaa`,
  the_bahamas: `Bahama`,
  the_gambia: `Gambia`,
  togo: `Togo`,
  tonga: `Tonga`,
  trinidad_and_tobago: `Trinidad ja Tobago`,
  tunisia: `Tunisia`,
  turkey: `Turkki`,
  turkmenistan: `Turkmenistan`,
  tuvalu: `Tuvalu`,
  uganda: `Uganda`,
  ukraine: `Ukraina`,
  united_arab_emirates: `Yhdistyneet arabiemiirikunnat`,
  united_kingdom: `Yhdistynyt kuningaskunta`,
  united_states: `Yhdysvallat`,
  uruguay: `Uruguay`,
  uzbekistan: `Uzbekistan`,
  vanuatu: `Vanuatu`,
  vatican_city: `Vatikaanikaupunki`,
  venezuela: `Venezuela`,
  vietnam: `Vietnam`,
  yemen: `Jemen`,
  zambia: `Sambia`,
  zimbabwe: `Zimbabwe`,
  already_registered: `Oletko jo rekisteröitynyt?`,
  login_here: `Kirjaudu sisään tästä`,
  application_to: `Hakemus kohteeseen`,
  continue_application: `Jatka hakemusta`,
  delete_application: `Poista sovellus`,
  edit_resubmit: `Muokkaa ja lähetä uudelleen`,
  withdraw: `Peruuttaa`,
  this_will_withdraw_your_application_and_return_it_to_a_pending_state: `Tämä peruuttaa hakemuksesi ja palauttaa sen Odottaa-tilaan.`,
  this_will_delete_your_application_and_saved_data: `Tämä poistaa sovelluksesi ja tallennetut tiedot.`,
  withdraw_application: `Peru hakemus`,
  send: `Lähetä`,
  enable_editing_of_application: `Ota sovelluksen muokkaus käyttöön`,
  application_editing_enabled: `Sovellusten muokkaus käytössä`,
  pre_approve: `Hyväksy etukäteen`,
  withdraw_pre_approval: `Peru ennakkohyväksyntä`,
  confirm_approval: `Vahvista hyväksyntä`,
  grant_award: `Apurahapalkinto`,
  please_confirm_you_wish_to_approve_this_application: `Vahvista, että haluat hyväksyä tämän hakemuksen.`,
  share_a_message: `Jaa viesti:`,
  confirm_decline: `Vahvista Hylkääminen`,
  please_explain_your_decision_to_the_applicant: `Perustele päätöksesi hakijalle`,
  application_related: `Sovellukseen liittyvä`,
  entity_related: `Entity Related`,
  programme_related: `Ohjelmaan liittyvä`,
  add_a_message: `Lisää viesti`,
  there_are_items_we_cannot_fund: `On kohteita, joita emme voi rahoittaa`,
  the_impact_of_your_project_is_not_clear_enough: `Hankkeesi vaikutus ei ole tarpeeksi selvä`,
  the_impact_of_your_project_is_lower_relative_to_other_applications: `Projektisi vaikutus on pienempi verrattuna muihin sovelluksiin.`,
  your_entity_does_not_meet_our_criteria: `Yhteisösi ei täytä kriteereitämme`,
  your_project_does_not_align_closely_enough_with_our_objectives: `Projektisi ei ole riittävän linjassa tavoitteidemme kanssa`,
  other_projects_more_closely_aligned_with_our_objectives: `Muut hankkeet ovat paremmin tavoitteidemme mukaisia`,
  your_project_did_not_fully_meet_our_eligibility_criteria: `Projektisi ei täysin täyttänyt kelpoisuusehtojamme`,
  funding_in_this_round_has_already_been_disbursed_to_similar_projects: `Tämän kierroksen rahoitus on jo maksettu vastaaville hankkeille`,
  please_select_an_decline_option_or_write_a_message: `Valitse hylkäysvaihtoehto tai kirjoita viesti`,
  confirm_pre_approval: `Vahvista ennakkohyväksyntä`,
  please_confirm_your_pre_approval: `Vahvista ennakkohyväksyntäsi.`,
  please_confirm_your_approval: `Vahvista hyväksyntäsi.`,
  pre_approving_will_not_notify_the_applicant: `Ennakkohyväksyntä ei ilmoita hakijalle.`,
  approving_will_not_notify_the_applicant: `Hyväksymisestä ei ilmoiteta hakijalle.`,
  internal_review: `Sisäinen tarkistus`,
  entity_history: `Kokonaisuuden historia`,
  you_have_received_an_application_from_this_entity_before: `Olet saanut hakemuksen tältä taholta aiemmin.`,
  approval: `Hyväksyminen`,
  approved_by: `Hyväksytty`,
  confirm_step_completion: `Vahvista vaiheen suorittaminen`,
  please_confirm_this_step_has_been_completed: `Vahvista, että tämä vaihe on suoritettu.`,
  total_score: `Kokonaispisteet`,
  voters: `äänestäjät`,
  category_totals: `Luokkasummat`,
  name: `Nimi`,
  telephone: `Puhelin`,
  email: `Sähköposti`,
  category_score: `Luokkapisteet`,
  date: `Päivämäärä`,
  my_vote: `Minun Ääneni`,
  saved: `Tallennettu`,
  vote: `Äänestää`,
  value_for_money: `Vastinetta rahoille`,
  total_impact: `Kokonaisvaikutus`,
  total: `Kokonais`,
  comments: `Kommentit`,
  edit: `Muokata`,
  what_are_your_overall_comments: `Mitkä ovat yleiskommenttisi?`,
  select_score: `Valitse Pisteet`,
  please_select_at_least_one_checkbox: `Valitse vähintään yksi valintaruutu`,
  create_your_profile: `Luo profiilisi`,
  on_the_following_screens_you_will_be_asked_to_complete_a_profile_of_your_entity: `Seuraavilla näytöillä sinua pyydetään täyttämään entiteettisi profiili.`,
  how_your_profile_is_used: `Kuinka profiiliasi käytetään`,
  once_your_profile_is_complete_it_will_be_automatically_attached_to_any_application_you_submit_through_bizGive: `Kun profiilisi on valmis, se liitetään automaattisesti kaikkiin BizGiven kautta lähetettyihin hakemuksiin.`,
  companies_and_bizGive_use_your_profile_to_perform_background_due_diligence_checks_on_your_organisation_it_is_only_visible_to_companies_you_apply_to: `Yritykset ja BizGive käyttävät profiiliasi taustan due diligence -tarkistuksia organisaatiollesi. Se näkyy vain yrityksille, joihin haet.`,
  once_complete_you_will_be_able_to_apply_to_as_many_company_programmes_as_you_re_eligible_for_from_the_discover_tab: `Kun olet valmis, voit hakea niin moneen yrityksen ohjelmaan kuin olet oikeutettu "Löydä"-välilehdeltä.`,
  profile_guidance: `Profiilin opastus`,
  saves_your_data_and_moves_you_to_the_next_screen_your_answers_will_automatically_be_saved_unless_you_have_an_internet_connectivity_issue: `tallentaa tietosi ja siirtää sinut seuraavaan näyttöön. Vastauksesi tallennetaan automaattisesti, ellei sinulla ole Internet-yhteysongelmia.`,
  saves_your_data_and_logs_you_out_of_bizGive: `tallentaa tietosi ja kirjaa sinut ulos BizGivestä. Voit jatkaa profiiliasi, kun kirjaudut takaisin sisään. Sinun on täytettävä kaikki vaaditut kentät "Tallenna ja poistu" (voit laittaa satunnaisen val.`,
  entity_details: `Yhteisön tiedot`,
  name_n_address: `Nimi & Osoite`,
  do_you_have_a_different_trading_name_or_display_name: `Onko sinulla eri kauppanimi tai näyttönimi?`,
  legal_structure: `Oikeudellinen rakenne`,
  what_is_your_legal_structure: `Mikä on oikeudellinen rakenteenne?`,
  unregistered_organisation: `Rekisteröimätön organisaatio`,
  what_is_your_registration_number: `Mikä on rekisteröintinumerosi?`,
  this_is_your_registration_number_with_the_relevant_regulator_of_your_entity: `Tämä on rekisteröintinumerosi yhteisösi asiaankuuluvan sääntelyviranomaisen kanssa.`,
  please_share_a_link_to_your_online_registration: `Ole hyvä ja jaa linkki online-rekisteröintiisi`,
  this_is_a_link_to_your_profile_on_the_regulators_website: `Tämä on linkki profiiliisi sääntelyviranomaisen verkkosivustolla.`,
  please_upload_a_copy_of_your_governing_document: `Lataa kopio hallintoasiakirjoistasi`,
  these_are_not_available: `Näitä ei ole saatavilla`,
  please_share_a_reason: `Kerro syy`,
  please_upload_a_copy_of_your_governing_documents: `Lataa kopio hallintoasiakirjoistasi`,
  for_example_your_trust_deed: `Esimerkiksi luottamustehtäväsi.`,
  please_upload_a_copy_of_your_most_recent_annual_accounts: `Lähetä kopio viimeisimmästä tilinpäätöksestäsi`,
  for_example_your_Articles_of_association: `Esimerkiksi yhtiöjärjestyksenne.`,
  please_upload_a_copy_of_your_constitution_trust_deed_or_rules: `Lataa kopio perustuslaistasi, luottamusasiakirjastasi tai säännöistäsi`,
  please_upload_a_copy_of_your_registration_documents_or_most_recent_annual_accounts: `Lataa kopio rekisteröintiasiakirjoista tai viimeisimmistä tilinpäätöksistä`,
  entity_types: `Entiteettityypit`,
  registered_with_the_relevant_national_or_regional_regulatory_authority_for_example_the_charity_commission_in_the_uk: `Asianomaisen kansallisen tai alueellisen sääntelyviranomaisen rekisteröimä. Esimerkiksi Yhdistyneen kuningaskunnan Charity Commission.`,
  community_interest_company_uk_only: `Community Interest Company (vain Iso-Britannia)`,
  registered_with_companies_house: `Rekisteröity Companies Houseen. Ei-hyväntekeväisyysyhtiön erityinen muoto, joka on olemassa yhteisön hyödyksi tai yhteiskunnalliseen tarkoitukseen. Monet sosiaaliset yritykset ovat CIC-yrityksiä.`,
  a_type_of_charity_run_by_a_small_group_of_people_known_as_trustees: `Hyväntekeväisyysjärjestö, jota johtaa pieni joukko ihmisiä, jotka tunnetaan luottamushenkilöinä. Yhdistyneessä kuningaskunnassa säätiön on rekisteröidyttävä Charity Commissioniin, kun sen vuositulot ylittävät 5 000 puntaa.`,
  an_educational_institution_such_as_a_university_or_school: `Oppilaitos, kuten yliopisto tai koulu.`,
  an_entity_that_is_not_registered_or_regulated_for_example_clubs_societies_and_small_community_groups: `Yksikkö, jota ei ole rekisteröity tai säännelty. Esimerkiksi klubit, seurat ja pienet yhteisöryhmät.`,
  a_type_of_charitable_organisation_registered_as_a_company_limited_by_guarantee: `Hyväntekeväisyysjärjestötyyppi, joka on rekisteröity Company Limited by Guarantee -nimellä tai muulla voittoa tavoittelemattomalla yritysrakenteella. Isossa-Britanniassa ne on rekisteröity Companies House as a Company Limited by Gu -yhtiöön`,
  organisations_that_are_responsible_for_the_provision_of_public_services: `Organisaatiot, jotka vastaavat julkisten palvelujen tuottamisesta.`,
  trustees: `Edunvalvojat`,
  please_provide_the_name_of_your_trustees_or_directors: `Anna luottamusmiestesi tai johtajien nimet.`,
  a_minimum_of_two_is_required_only_1_is_required_if_you_are_a_uk_cic: `Vähintään 2 vaaditaan. Vain 1 vaaditaan, jos olet Yhdistyneen kuningaskunnan CIC.`,
  where_are_you_able_to_run_your_projects: `Missä voit toteuttaa projektejasi?`,
  based_on_your_selections_we_will_be_able_to_recommend_relevant_new_funding_programmes_to_you: `Valintasi perusteella voimme suositella sinulle sopivia uusia rahoitusohjelmia.`,
  countries_of_operation: `Toimintamaat`,
  within_your_selected_countries_can_you_run_projects_nationwide_or_in_specific_locations_only: `Voitko toteuttaa projekteja valitsemissasi maissa valtakunnallisesti vai vain tietyissä paikoissa?`,
  nationwide: `Valtakunnallinen`,
  specific_locations: `Tarkat sijainnit`,
  please_describe_what_your_organisation_does: `Kuvaile, mitä organisaatiosi tekee`,
  please_provide_a_brief_overview_of_your_groups_purpose_aims_and_objectives: `Anna lyhyt katsaus ryhmäsi tarkoitukseen, päämääriin ja päämääriin.`,
  social_media: `Sosiaalinen media`,
  please_share_a_link_to_your_website: `Jaa linkki verkkosivustollesi`,
  if_applicable_please_share_your_social_media_links: `Jos mahdollista, jaa linkit sosiaaliseen mediaan`,
  please_add_your_entity_logo: `Lisää yhteisösi logo`,
  please_upload: `Lataa`,
  your_profile_is_complete: `Profiilisi on valmis`,
  you_can: `Voit`,
  edit_title_caption: `'Muokata'`,
  your_profile_at_any_point_by_clicking_into: `profiilisi milloin tahansa napsauttamalla "Oma organisaatio" > "Profiili" > "Muokkaa"`,
  what_happens_next: `Mitä seuraavaksi tapahtuu?`,
  start_your_application: `Aloita sovelluksesi`,
  if_you_accessed_bizGive_via_a_company_programme: `Jos käytit BizGiveä yrityksen ohjelman kautta, napsauta "Hae" aloittaaksesi hakulomakkeen.`,
  discover_company_programmes: `Tutustu yritysohjelmiin`,
  click_discover_to_view_and_apply_to_live_company_support_programmes: `Napsauta "Löydä" nähdäksesi ja hakeaksesi reaaliaikaisia ​​yritystukiohjelmia.`,
  enter_url: `Anna URL-osoite`,
  please_upload_documentation: `Lataa dokumentaatio`,
  council_or_government_linked_entity: `neuvosto tai hallitussidonnainen yhteisö`,
  locations: `Sijainnit`,
  specific_locations_within_each_country: `Tietyt paikat kussakin maassa`,
  entity_type: `Yhteisötyyppi`,
  legal_name: `Virallinen nimi`,
  governing_documents: `Hallintoasiakirjat`,
  operating_location: `Toimintapaikka`,
  nationally_in_the_following_countries: `Kansallisesti seuraavissa maissa:`,
  locally_in_the_following_countries: `Paikallisesti seuraavissa maissa:`,
  not_available: `Ei saatavilla`,
  registration_number: `Rekisterinumero`,
  trading_name: `Kaupan nimi`,
  web_uri: `Web-URI`,
  registration_profile_url: `Rekisteröintiprofiilin URL-osoite`,
  discover_funding_opportunities: `Tutustu rahoitusmahdollisuuksiin`,
  available_programmes_filtered_by_your_entitys_area_of_operation: `Käytettävissä olevat ohjelmat, jotka on suodatettu entiteettisi toiminta-alueen mukaan:`,
  change_here: `Muuta tästä`,
  programme: `Ohjelmoida`,
  applications_accepted: `Hakemukset hyväksytty`,
  decision_made: `Päätös tehty`,
  location: `Sijainti`,
  action: `Toiminta `,
  your_entity_type_is_not_supported_by_this_programme: `Tämä ohjelma ei tue entiteettityyppiäsi.`,
  please_click_ok_and_view_the_permitted_entities_in_the_programme_review_page: `Napsauta "OK" ja tarkastele sallittuja kokonaisuuksia ohjelman tarkistussivulla.`,
  content: `Sisältö`,
  select_programme: `Valitse Ohjelma`,
  select_report_type: `Valitse Raportin tyyppi`,
  enter_start_date: `Anna aloituspäivämäärä`,
  enter_end_date: `Anna lopetuspäivämäärä`,
  report: `Raportoi`,
  overdue: `Myöhässä`,
  view_report: `Näytä raportti`,
  start_report: `Aloita raportti`,
  complete_report: `Täydellinen raportti`,
  add_your_profile_picture: `Lisää profiilikuvasi`,
  project: `Projekti`,
  registration_website: `Rekisteröintisivusto`,
  outside_of_impact_area: `Iskualueen ulkopuolella`,
  this_interim_update_is_for: `Tämä välipäivitys on tarkoitettu`,
  interim_update_deadline: `Väliaikainen päivityksen määräaika`,
  form_guidance: `Lomakeopas`,
  in_the_form_you_will_be_asked_to_share_details_of_the_project_you_received_funding_for: `Lomakkeessa sinua pyydetään jakamaan tiedot hankkeesta, johon olet saanut rahoitusta.`,
  to_access_a_saved_interim_update_click_into_impact: `Tallennetun välipäivityksen käyttäminen: Napsauta kohtaa Vaikutus > Sisältö > Täydellinen raportti`,
  to_access_a_saved_interim_update_click_into_impact_content: `Lähetetyn välipäivityksen tarkasteleminen: Napsauta kohtaa Vaikutus > Sisältö > Näytä raportti`,
  interim_update: `Väliaikainen päivitys`,
  below_is_the_support_you_requested_from_the_company_in_your_application: `Alla on tuki, jota pyysit yritykseltä hakemuksessasi.`,
  how_have_you_used_the_support_provided_so_far: `Miten olet käyttänyt tähän mennessä saamaasi tukea?`,
  are_there_any_changes_to_your_planned_expenditure_and_if_so_why: `Onko suunniteltuihin menoihin muutoksia, ja jos on, miksi?`,
  are_there_any_changes_to_your_estimated_completion_date_and_if_so_why: `Onko arvioituun valmistumispäivääsi muutoksia ja jos on, miksi?`,
  please_email_bizGive: `Lähetä sähköpostia BizGivelle`,
  if_there_is_a_substantial_change_to_your_completion_date_and_we_will_ensure_the_deadline_for_your_final_report_is_update: `jos valmistumispäivämääräsi muuttuu olennaisesti, ja varmistamme, että loppuraporttisi määräaika päivitetään.`,
  share_images: `Jaa kuvia`,
  please_upload_images_to_bring_your_project_to_life_this_significantly_increases_the_likelihood_of_the_company_sharing_your_content: `Lataa kuvia saadaksesi projektisi eloon. Tämä lisää merkittävästi todennäköisyyttä, että yritys jakaa sisältöäsi.`,
  sends_your_form_to_the_company: `lähettää raportin yritykselle. Tämä painike tulee näkyviin lomakkeen viimeiseen näyttöön.`,
  submit_your_report: `Lähetä raporttisi`,
  i_have_read_and_agree_to_the_above_terms: `Olen lukenut ja hyväksyn yllä olevat ehdot.`,
  add_files: `Lisää tiedostoja`,
  please_confirm_that_all_necessary_copyrights_and_acknowledgements_have_been_added: `Vahvista, että kaikki tarvittavat tekijänoikeudet ja tunnustukset on lisätty.`,
  i_confirm_that_all_necessary_copyrights_and_acknowledgements_have_been_added: `Vahvistan, että kaikki tarvittavat tekijänoikeudet ja tunnustukset on lisätty.`,
  final_report_deadline: `Loppuraportin määräaika`,
  please_press_add_to_save_the_invited_user: `Paina lisää tallentaaksesi kutsutun käyttäjän`,
  inputs: `Tulot`,
  did_any_of_your_plans_change: `Muuttuiko jokin suunnitelmistasi?`,
  please_select_and_enter_your_final_inputs: `Valitse ja anna lopulliset syötteet`,
  please_update_your_expenditure: `Päivitä kulusi`,
  please_update_the_items_or_services_you_used: `Päivitä käyttämäsi tuotteet tai palvelut`,
  please_update_the_volunteering_support_you_used: `Päivitä käyttämäsi vapaaehtoistyön tuki`,
  below_are_the_outputs_you_shared_in_your_application: `Alla on tulosteet, jotka jaoit sovelluksessasi.`,
  did_your_outputs_change: `Muuttuivatko tuotosi?`,
  please_update_your_outputs: `Päivitä tulosteet`,
  your_outputs_will_show_like_this_in_your_report: `Tuotosi näkyvät raportissasi näin:`,
  i_acknowledge_the: `tunnustan`,
  below_are_the_beneficiaries_you_shared_in_your_application: `Alla ovat edunsaajat, jotka jaoit hakemuksessasi.`,
  did_your_social_beneficiary_types_change: `Muuttuivatko sosiaalietuuksien saajatyypit?`,
  please_update_your_social_beneficiary_types: `Päivitä sosiaaliset edunsaajatyypit`,
  did_your_social_beneficiary_numbers_change: `Muuttuivatko sosiaalietuuksienne numerot?`,
  please_update_your_social_beneficiary_numbers: `Päivitä sosiaalietuuksien numerosi`,
  did_your_environmental_beneficiaries_change: `Muuttuivatko ympäristön edunsaajat?`,
  please_update_your_environmental_beneficiaries: `Päivitä ympäristön edunsaajat`,
  below_are_the_objectives_and_outcomes_you_shared_in_your_application: `Alla on hakemuksessasi jakamasi tavoitteet ja tulokset.`,
  objectives_n_outcomes: `Tavoitteet & Tulokset`,
  were_you_successful_in_achieving_your_objectives_and_outcomes: `Onnistuitko saavuttamaan tavoitteesi ja tuloksesi?`,
  inputs_n_outputs: `Tulot ja lähdöt`,
  case_studies: `Tapaustutkimukset`,
  preview_n_submit: `Esikatsele ja lähetä`,
  impact_measures: `Vaikutustoimenpiteet`,
  the_company_has_requested_you_to_add_indicators_to_measure_the_progress_of_your_project: `Yritys on pyytänyt sinua lisäämään indikaattoreita mittaamaan projektisi edistymistä.`,
  general_indicators: `Yleiset indikaattorit`,
  these_indicators_are_general_to_your_opportunity_or_entity_please_click_add_to_create_them: `Nämä indikaattorit koskevat mahdollisuuttasi tai kokonaisuuttasi. Luo ne napsauttamalla Lisää.`,
  indicator: `Ilmaisin`,
  required: `Pakollinen?`,
  target: `Kohde`,
  final_title: `Lopullinen`,
  status: `Status`,
  project_indicators: `Hankkeen indikaattorit`,
  the_indicators_below_are_linked_to_your_selected_objectives_and_outcomes_please_click_add_to_create_them: `Alla olevat indikaattorit liittyvät valitsemiisi tavoitteisiin ja tuloksiin. Luo ne napsauttamalla Lisää.`,
  objective: `Tavoite`,
  outcome: `Tulokset`,
  achieved: `Saavutettu`,
  your_absolute_impact_is: `Absoluuttinen vaikutuksesi on ImpactNumber`,
  your_relative_impact_is: `Suhteellinen vaikutus on ImpactNumber`,
  case_studies_and_media: `Tapaustutkimukset ja media`,
  case_studies_and_images_increase_the_likelihood_of_the_company_sharing_your_project_where_possible_please_share_a_case_study_and_at_least_one_image: `Tapaustutkimukset ja kuvat lisäävät todennäköisyyttä, että yritys jakaa projektisi. Jos mahdollista, jaa tapaustutkimus ja vähintään yksi kuva.`,
  add_case_study: `Lisää tapaustutkimus`,
  add_images: `Lisää kuvia`,
  please_upload_this_file_type_in_the_add_files_section_below: `Lataa tämä tiedostotyyppi alla olevaan Lisää tiedostoja -osioon`,
  please_upload_images_in_the_additional_images_section_above: `Lataa kuvat yllä olevaan Lisäkuvat-osioon`,
  upload_any_image_files_here_png_jpg: `Lataa tänne mitä tahansa kuvatiedostoja, esim. .png, .jpg`,
  upload_any_documents_that_you_wish_to_share: `Lataa kaikki asiakirjat, jotka haluat jakaa, esim. .doc, .pdf tai .xlsx`,
  case_study_name: `Tapaustutkimuksen nimi`,
  what_impact_did_your_project_have: `Millainen vaikutus projektillasi oli?`,
  add_a_description: `Lisää kuvaus`,
  for_example_what_was_there_at_start_what_did_you_do_and_what_was_the_result: `Esimerkiksi: mitä siellä oli alussa, mitä teit ja mikä oli tulos?`,
  share_a_quote_such_as_from_a_beneficiary: `Jaa tarjous, esimerkiksi edunsaajalta`,
  quote_by: `Lainaus`,
  please_share_any_images: `Ole hyvä ja jaa kuvia`,
  what_happens_next_for_example_are_you_planning_to_develop_your_project_further: `Mitä tapahtuu seuraavaksi, esimerkiksi aiotteko kehittää projektianne edelleen?`,
  if_you_would_like_to_share_anything_else_with_the_company_please_use_the_box_below: `Jos haluat jakaa jotain muuta yrityksen kanssa, käytä alla olevaa laatikkoa`,
  the_company_has_requested_some_additional_information: `Yhtiö on pyytänyt lisätietoja.`,
  content_agreement: `Sisältösopimus`,
  view_agreement: `Katso sopimus`,
  application_agreement: `Hakemussopimus`,
  send_message: `Lähetä Viesti`,
  this_final_Report_is_for: `Tämä loppuraportti on tarkoitettu`,
  company_questions: `Yrityksen kysymykset`,
  next_steps: `Seuraavat vaiheet`,
  additional_details: `Lisätiedot`,
  objectives_and_outcomes: `Tavoitteet ja tulokset`,
  planned: `Suunniteltu`,
  actual: `Todellinen`,
  days: `päivää`,
  of_equivalent_value: `vastaava arvo`,
  case_study: `Tapaustutkimus`,
  includes_changes: `Sisältää muutokset`,
  hundred_as_planned: `100% suunnitellusti`,
  show_planned_efforts: `Näytä suunnitellut toimet`,
  final: `Lopullinen`,
  support_awarded: `Tuki myönnetty`,
  password_reset_expired: `Salasanan palautus vanhentunut`,
  please_select_forgot_password_again_and_click_on_the_email_to_reset_your_password_within_fifteen_minutes: `Valitse "Unohditko salasanasi" uudelleen ja napsauta sähköpostiviestiä palauttaaksesi salasanasi 15 minuutin kuluessa.`,
  please_check_check_your_spam_folder_if_the_email_is_not_immediately_visible: `Tarkista roskapostikansiosi, jos sähköposti ei näy heti.`,
  request: `Pyytää`,
  please_note_this_email_address_needs_to_match_the_address: `Huomaa: tämän sähköpostiosoitteen on vastattava osoitetta, johon sait kutsusi.`,
  an_access_email_has_sent_to: `Käyttöoikeussähköposti on lähetetty osoitteeseen:`,
  you_can_close_this_tab: `Voit sulkea tämän välilehden.`,
  we_couldnt_find_your_email_address: `Emme löytäneet sähköpostiosoitettasi. Varmista, että se on sama kuin sähköpostikutsu.`,
  the_feedback_portal_link_has_now_expired: `Palauteportaalin linkki on nyt vanhentunut.`,
  please_contact_your_programme_administrator_if_you_still_require_access: `Ota yhteyttä ohjelman ylläpitäjään, jos tarvitset edelleen käyttöoikeuksia.`,
  verify: `Vahvista`,
  the_email_address_entered_does_not_match_your_unique_link_please_ensure_it_is_the_same_as_your_invitation_email: `Annettu sähköpostiosoite ei vastaa yksilöllistä linkkiäsi. Varmista, että se on sama kuin sähköpostikutsu.`,
  email_entered: `Sähköposti syötetty`,
  try_again: `Yritä uudelleen`,
  welcome_to_your_voting_panel: `Tervetuloa äänestyspaneeliisi!`,
  please_click_review_to_assess_each_application_and_then_cast_your_vote: `Arvioi jokainen hakemus napsauttamalla Tarkistaa ja äänestä sitten.`,
  please_enter_your_name: `Kirjoita nimesi`,
  registered_charity: `Rekisteröity hyväntekeväisyysjärjestö`,
  charitable_company: `Hyväntekeväisyysyritys`,
  community_interest_company: `Yhteisön edun mukaista yritystä`,
  charitable_trust: `Hyväntekeväisyyssäätiö`,
  for_profit_company: `Profit Companylle`,
  academic_institution: `Akateeminen laitos`,
  government_linked_entity: `Hallitukseen linkitetty taho`,
  parish_or_community_council: `Seurakunta- tai seurakuntaneuvosto`,
  please_upload_a_copy_of_your_governing_document1: `Lataa kopio hallintoasiakirjastasi`,
  please_upload_a_copy_of_your_governing_document2: `Lataa kopio hallintoasiakirjastasi`,
  please_upload_a_copy_of_your_governing_document4: `Lataa kopio hallintoasiakirjastasi`,
  insert_number: `Lisää numero`,
  bring_the_project_to_life_share_pictures_of_what_you_will_be_changing_or_plan_to_achieve: `Herätä projekti henkiin. Jaa kuvia siitä, mitä aiot muuttaa tai mitä aiot saavuttaa.`,
  please_select_an_existing_user_or_invite_a_new_one: `Valitse olemassa oleva käyttäjä tai kutsu uusi.`,
  decisions_to_be_made: `Tehtäviä päätöksiä:`,
  please_add_at_least_one_criteria: `Lisää vähintään yksi kriteeri`,
  see_full_report: `Katso koko raportti`,
  internal_actions: `Sisäiset toimet`,
  country_af: `Afganistan`,
  country_ax: `Ahvenanmaa`,
  country_al: `Albania`,
  country_dz: `Algeria`,
  country_as: `Amerikan Samoa`,
  country_ad: `Andorra`,
  country_ao: `Angola`,
  country_ai: `Anguilla`,
  country_aq: `Etelämanner`,
  country_ag: `Antigua ja Barbuda`,
  country_ar: `Argentiina`,
  country_am: `Armenia`,
  country_aw: `Aruba`,
  country_au: `Australia`,
  country_at: `Itävalta`,
  country_az: `Azerbaidžan`,
  country_bs: `Bahama`,
  country_bh: `Bahrain`,
  country_bd: `Bangladesh`,
  country_bb: `Barbados`,
  country_by: `Valko-Venäjä`,
  country_be: `Belgia`,
  country_bz: `Belize`,
  country_bj: `Benin`,
  country_bm: `Bermuda`,
  country_bt: `Bhutan`,
  country_bo: `Bolivia, monikansallinen osavaltio`,
  country_bq: `Bonaire, Sint Eustatius ja Saba`,
  country_ba: `Bosnia ja Hertsegovina`,
  country_bw: `Botswana`,
  country_bv: `Bouvetin saari`,
  country_br: `Brasilia`,
  country_io: `Brittiläinen Intian valtameren alue`,
  country_bn: `Brunei Darussalam`,
  country_bg: `Bulgaria`,
  country_bf: `Burkina Faso`,
  country_bi: `Burundi`,
  country_cv: `Cabo Verde`,
  country_kh: `Kambodža`,
  country_cm: `Kamerun`,
  country_ca: `Kanada`,
  country_ky: `Caymansaaret`,
  country_cf: `Keski-Afrikan tasavalta`,
  country_td: `Tšad`,
  country_cl: `Chile`,
  country_cn: `Kiina`,
  country_cx: `Joulusaari`,
  country_cc: `Kookossaaret (Keeling).`,
  country_co: `Kolumbia`,
  country_km: `Komorit`,
  country_cg: `Kongo`,
  country_cd: `Kongo, Demokraattinen tasavalta`,
  country_ck: `Cookin saaret`,
  country_cr: `Costa Rica`,
  country_ci: `Norsunluurannikko`,
  country_hr: `Kroatia`,
  country_cu: `Kuuba`,
  country_cw: `Curaçao`,
  country_cy: `Kypros`,
  country_cz: `Tšekki`,
  country_dk: `Tanska`,
  country_dj: `Djibouti`,
  country_dm: `Dominica`,
  country_do: `Dominikaaninen tasavalta`,
  country_ec: `Ecuador`,
  country_eg: `Egypti`,
  country_sv: `El Salvador`,
  country_gq: `Päiväntasaajan Guinea`,
  country_er: `Eritrea`,
  country_ee: `Viro`,
  country_sz: `Eswatini`,
  country_et: `Etiopia`,
  country_fk: `Falklandinsaaret (Malviinit)`,
  country_fo: `Färsaaret`,
  country_fj: `Fidži`,
  country_fi: `Suomi`,
  country_fr: `Ranska`,
  country_gf: `Ranskan Guayana`,
  country_pf: `Ranskan Polynesia`,
  country_tf: `Ranskan eteläiset alueet`,
  country_ga: `Gabon`,
  country_gm: `Gambia`,
  country_ge: `Georgia`,
  country_de: `Saksa`,
  country_gh: `Ghana`,
  country_gi: `Gibraltar`,
  country_gr: `Kreikka`,
  country_gl: `Grönlanti`,
  country_gd: `Grenada`,
  country_gp: `Guadeloupe`,
  country_gu: `Guam`,
  country_gt: `Guatemala`,
  country_gg: `Guernseyssä`,
  country_gn: `Guinea`,
  country_gw: `Guinea-Bissau`,
  country_gy: `Guyana`,
  country_ht: `Haiti`,
  country_hm: `Heard Island ja McDonald Islands`,
  country_va: `Pyhä istuin`,
  country_hn: `Honduras`,
  country_hk: `Hong Kong`,
  country_hu: `Unkari`,
  country_is: `Islanti`,
  country_in: `Intia`,
  country_id: `Indonesia`,
  country_ir: `Iran, islamilainen tasavalta`,
  country_iq: `Irak`,
  country_ie: `Irlanti`,
  country_im: `Mansaari`,
  country_il: `Israel`,
  country_it: `Italia`,
  country_jm: `Jamaika`,
  country_jp: `Japani`,
  country_je: `Jersey`,
  country_jo: `Jordania`,
  country_kz: `Kazakstan`,
  country_ke: `Kenia`,
  country_ki: `Kiribati`,
  country_kp: `Korea, demokraattinen kansantasavalta`,
  country_kr: `Korea, tasavalta`,
  country_kw: `Kuwait`,
  country_kg: `Kirgisia`,
  country_la: `Laon demokraattinen kansantasavalta`,
  country_lv: `Latvia`,
  country_lb: `Libanon`,
  country_ls: `Lesotho`,
  country_lr: `Liberia`,
  country_ly: `Libya`,
  country_li: `Liechtenstein`,
  country_lt: `Liettua`,
  country_lu: `Luxemburg`,
  country_mo: `Macao`,
  country_mg: `Madagaskar`,
  country_mw: `Malawi`,
  country_my: `Malesia`,
  country_mv: `Malediivit`,
  country_ml: `Mali`,
  country_mt: `Malta`,
  country_mh: `Marshallin saaret`,
  country_mq: `Martinique`,
  country_mr: `Mauritania`,
  country_mu: `Mauritius`,
  country_yt: `Mayotte`,
  country_mx: `Meksiko`,
  country_fm: `Mikronesia, liittovaltiot`,
  country_md: `Moldova, tasavalta`,
  country_mc: `Monaco`,
  country_mn: `Mongolia`,
  country_me: `Montenegro`,
  country_ms: `Montserrat`,
  country_ma: `Marokko`,
  country_mz: `Mosambik`,
  country_mm: `Myanmar`,
  country_na: `Namibia`,
  country_nr: `Nauru`,
  country_np: `Nepal`,
  country_nl: `Alankomaat, Britannian kuningaskunta`,
  country_nc: `Uusi-Kaledonia`,
  country_nz: `Uusi-Seelanti`,
  country_ni: `Nicaragua`,
  country_ne: `Niger`,
  country_ng: `Nigeria`,
  country_nu: `Niue`,
  country_nf: `Norfolkin saari`,
  country_mk: `Pohjois-Makedonia`,
  country_mp: `Pohjois-Mariaanit`,
  country_no: `Norja`,
  country_om: `Oman`,
  country_pk: `Pakistan`,
  country_pw: `Palau`,
  country_ps: `Palestiina, osavaltio`,
  country_pa: `Panama`,
  country_pg: `Papua-Uusi-Guinea`,
  country_py: `Paraguay`,
  country_pe: `Peru`,
  country_ph: `Filippiinit`,
  country_pn: `Pitcairn`,
  country_pl: `Puola`,
  country_pt: `Portugali`,
  country_pr: `Puerto Rico`,
  country_qa: `Qatar`,
  country_re: `Réunion`,
  country_ro: `Romania`,
  country_ru: `Venäjän federaatio`,
  country_rw: `Ruanda`,
  country_bl: `Saint Barthélemy`,
  country_sh: `Pyhä Helena, Ascension ja Tristan da Cunha`,
  country_kn: `Saint Kitts ja Nevis`,
  country_lc: `Saint Lucia`,
  country_mf: `Saint Martin (ranskalainen osa)`,
  country_pm: `Saint Pierre ja Miquelon`,
  country_vc: `Saint Vincent ja Grenadiinit`,
  country_ws: `Samoa`,
  country_sm: `San Marino`,
  country_st: `São Tome ja Principe`,
  country_sa: `Saudi-Arabia`,
  country_sn: `Senegal`,
  country_rs: `Serbia`,
  country_sc: `Seychellit`,
  country_sl: `Sierra Leone`,
  country_sg: `Singapore`,
  country_sx: `Sint Maarten (Hollannin osa)`,
  country_sk: `Slovakia`,
  country_si: `Slovenia`,
  country_sb: `Salomonsaaret`,
  country_so: `Somalia`,
  country_za: `Etelä-Afrikka`,
  country_gs: `Etelä-Georgia ja Eteläiset Sandwichsaaret`,
  country_ss: `Etelä-Sudan`,
  country_es: `Espanja`,
  country_lk: `Sri Lanka`,
  country_sd: `Sudan`,
  country_sr: `Suriname`,
  country_sj: `Svalbard ja Jan Mayen`,
  country_se: `Ruotsi`,
  country_ch: `Sveitsi`,
  country_sy: `Syyrian arabitasavalta`,
  country_tw: `Taiwan, Kiinan maakunta`,
  country_tj: `Tadžikistan`,
  country_tz: `Tansania, Yhdistynyt tasavalta`,
  country_th: `Thaimaa`,
  country_tl: `Itä-Timor`,
  country_tg: `Togo`,
  country_tk: `Tokelau`,
  country_to: `Tonga`,
  country_tt: `Trinidad ja Tobago`,
  country_tn: `Tunisia`,
  country_tr: `Turkkiye`,
  country_tm: `Turkmenistan`,
  country_tc: `Turks- ja Caicossaaret`,
  country_tv: `Tuvalu`,
  country_ug: `Uganda`,
  country_ua: `Ukraina`,
  country_ae: `Yhdistyneet arabiemiirikunnat`,
  country_gb: `Ison-Britannian ja Pohjois-Irlannin yhdistynyt kuningaskunta`,
  country_us: `Yhdysvallat`,
  country_um: `Yhdysvaltain pienet syrjäiset saaret`,
  country_uy: `Uruguay`,
  country_uz: `Uzbekistan`,
  country_vu: `Vanuatu`,
  country_ve: `Venezuela, Bolivarian tasavalta`,
  country_vn: `Vietnam`,
  country_vg: `Neitsytsaaret (Britti)`,
  country_vi: `Neitsytsaaret (USA)`,
  country_wf: `Wallis ja Futuna`,
  country_eh: `Länsi-Sahara`,
  country_ye: `Jemen`,
  country_zm: `Sambia`,
  country_zw: `Zimbabwe`
  }

export default fiLocale;
